/**
 * NB-014-DI: UpCart cart drawer CVR (Convert winner, always on)
 * - Keep Secure Checkout, Shipping Protection, add-ons from NB-005.
 * - Hide subscription + delivery-frequency controls in the cart drawer only.
 * - Style UpCart free-gift lines (__upcartFreeGift) as FREE + (Save $X).
 * - Kill switch: window.NB_UPCART_SUBSCRIBE_REDESIGN_FORCE_OFF = true
 * - Leftover Convert snippet is a no-op after start (__NB_UPCART_SUBSCRIBE_STARTED).
 */
(function () {
  'use strict';

  function main() {
  var STYLE_ID = 'nb-upcart-subscribe-redesign-v91';

  var NB_SUBSCRIPTION_LOCKED_HANDLES = ['smart-coffee-free-starter-kit'];

  var COL = {
    primary: '#1699F8',
    fillSelected: '#EFF6FF',
    borderCard: '#CCCCCC',
    text: '#000000',
    subtext: '#4A5565',
    label: '#364153',
  };

  var SCAN_DEBOUNCE_MS = 320;
  var nbScanDepth = 0;
  var nbRefreshTimer = null;
  var nbInteractUntil = 0;
  var nbCartMutation = null;
  var nbLineUi = Object.create(null);
  var nbFreqBusy = Object.create(null);
  var nbFreqSessions = Object.create(null);
  var nbFreqDelegationBound = false;
  var nbCartCache = null;
  var nbCartCacheAt = 0;
  var nbVariantSubPriceCache = Object.create(null);

  function nbFreqLog(msg, data) {
    if (window.NB_UPCART_SUBSCRIBE_DEBUG !== true) return;
    try {
      if (data !== undefined) console.log('[NB-FREQ]', msg, data);
      else console.log('[NB-FREQ]', msg);
    } catch (eLog) {}
  }

  function nbFreqSnapshot(markerId, host, tile) {
    var ui = tile ? readLineUi(tile) : null;
    return {
      markerId: markerId || (host && host.dataset && host.dataset.nbHostId) || null,
      hostConnected: !!(host && host.isConnected),
      tileKey: tile ? lineUiKey(tile) : null,
      busyToken: markerId ? nbFreqBusy[markerId] : undefined,
      lineUi: ui
        ? {
            pending: ui.pending,
            activating: ui.activating,
            deactivating: ui.deactivating,
            selected: ui.selected,
            expanded: ui.expanded,
          }
        : null,
    };
  }

  function markInteractCooldown(ms) {
    nbInteractUntil = Date.now() + (ms || 400);
  }

  function isInteractCooldown() {
    return Date.now() < nbInteractUntil;
  }

  function withCartMutation(fn) {
    if (nbCartMutation) {
      return nbCartMutation.then(fn);
    }
    nbCartMutation = Promise.resolve()
      .then(fn)
      .finally(function () {
        nbCartMutation = null;
      });
    return nbCartMutation;
  }

  function safeRemoveNode(node) {
    if (!node || !node.parentNode) return;
    try {
      node.parentNode.removeChild(node);
    } catch (err) {}
  }

  function pauseObsForScan() {
    nbScanDepth++;
    if (popupObserver) {
      popupObserver.disconnect();
      popupObserver = null;
    }
  }

  function resumeObsAfterScan() {
    nbScanDepth = Math.max(0, nbScanDepth - 1);
    if (nbScanDepth !== 0 || !observedEl || !observedEl.isConnected) return;
    if (popupObserver) return;
    popupObserver = new MutationObserver(function () {
      if (nbScanDepth > 0) return;
      scheduleScan();
    });
    popupObserver.observe(observedEl, { childList: true, subtree: true });
  }

  function injectStyles() {
    var staleStyles = document.querySelectorAll('style[id^="nb-upcart-subscribe-redesign-v"]');
    for (var s = 0; s < staleStyles.length; s++) {
      if (staleStyles[s].id !== STYLE_ID) staleStyles[s].remove();
    }
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent =
      '#CartPopup .upcart-public-component-product-tile__subscription-upgrade,' +
      '#CartPopup .upcart-internal-component-product-tile__subscription-upgrade{' +
      'min-height:56px!important;position:relative!important;display:block!important}' +
      '#CartPopup .upcart-public-component-product-tile__subscription-upgrade .upcart-public-component-product-tile__subscription-upgrade-btn,' +
      '#CartPopup .upcart-internal-component-product-tile__subscription-upgrade .upcart-internal-component-product-tile__subscription-upgrade-btn{' +
      'opacity:0!important;position:absolute!important;top:0!important;left:0!important;right:0!important;bottom:0!important;' +
      'width:100%!important;height:100%!important;min-height:56px!important;z-index:2!important;cursor:pointer!important;' +
      'margin:0!important;padding:0!important;border:none!important;background:transparent!important;box-shadow:none!important;' +
      'color:transparent!important;font-size:0!important;line-height:0!important;-webkit-appearance:none!important;appearance:none!important}' +
      '#CartPopup .upcart-public-component-product-tile__subscription-upgrade .upcart-public-component-product-tile__select-wrapper,' +
      '#CartPopup .upcart-internal-component-product-tile__subscription-upgrade .upcart-internal-component-product-tile__select-wrapper{' +
      'display:none!important}' +
      '#CartPopup .upcart-public-component-product-tile__subscription-upgrade:not(:has(+ .nb-sub-overlay))::after,' +
      '#CartPopup .upcart-internal-component-product-tile__subscription-upgrade:not(:has(+ .nb-sub-overlay))::after{' +
      'content:"";display:block;height:56px;border-radius:4px;border:1px solid #e5e7eb;background:#fafafa}' +
      '.upcart-public-component-product-tile__subscription-upgrade.nb-sub--ready,' +
      '.upcart-internal-component-product-tile__subscription-upgrade.nb-sub--ready,' +
      '#CartPopup .upcart-public-component-product-tile__subscription-upgrade.nb-sub--ready,' +
      '#CartPopup .upcart-internal-component-product-tile__subscription-upgrade.nb-sub--ready{' +
      'margin-top:12px!important;display:block!important;font-family:Poppins,system-ui,-apple-system,sans-serif;' +
      'min-height:56px!important;position:relative!important}' +
      '.nb-sub-static-card{margin-bottom:0}' +
      '.nb-sub-overlay{position:relative;z-index:1;pointer-events:none;margin:0}' +
      '.upcart-public-component-product-tile__subscription-upgrade + .nb-sub-overlay,' +
      '.upcart-internal-component-product-tile__subscription-upgrade + .nb-sub-overlay{' +
      'margin-top:-56px;min-height:56px}' +
      '.nb-sub-overlay .nb-sub-freq{margin-top:12px;pointer-events:auto}' +
      '.nb-sub--ready.nb-sub--selected + .nb-sub-overlay,.nb-sub--selected + .nb-sub-overlay{' +
      'pointer-events:auto!important;cursor:pointer!important}' +
      '.nb-sub--locked.nb-sub--selected + .nb-sub-overlay,.nb-sub--locked + .nb-sub-overlay,' +
      '.nb-sub-overlay.nb-sub-overlay--locked{' +
      'pointer-events:none!important;cursor:default!important}' +
      '.nb-sub--locked + .nb-sub-overlay .nb-sub-static-card__inner,' +
      '.nb-sub--locked .nb-sub-static-card__inner{cursor:default!important}' +
      '.nb-sub--locked .upcart-public-component-product-tile__subscription-upgrade-btn,' +
      '.nb-sub--locked .upcart-internal-component-product-tile__subscription-upgrade-btn{' +
      'pointer-events:none!important;cursor:default!important;opacity:0!important}' +
      '.nb-sub-static-card__inner{' +
      'display:flex;align-items:center;gap:12px;width:100%;box-sizing:border-box;cursor:pointer;' +
      'padding:10px 12px;border:1px solid ' +
      COL.borderCard +
      ';border-radius:4px;background:#fff}' +
      '.nb-sub--selected + .nb-sub-overlay .nb-sub-static-card__inner,' +
      '.nb-sub--selected .nb-sub-static-card__inner{' +
      'border:2px solid ' +
      COL.primary +
      ';background:' +
      COL.fillSelected +
      '}' +
      '.nb-sub-static-card__inner .nb-sub__price{align-self:center}' +
      '.nb-sub--card-pending + .nb-sub-overlay .nb-sub-static-card__inner,' +
      '.nb-sub--card-pending .nb-sub-static-card__inner,' +
      '.nb-sub-overlay.nb-sub-overlay--pending .nb-sub-static-card__inner{' +
      'opacity:.72!important;cursor:wait!important}' +
      '.nb-sub--card-pending + .nb-sub-overlay,' +
      '.nb-sub-overlay.nb-sub-overlay--pending{' +
      'pointer-events:none!important;cursor:wait!important}' +
      '.nb-sub--card-pending + .nb-sub-overlay .nb-sub__sync,' +
      '.nb-sub-overlay.nb-sub-overlay--pending .nb-sub__sync{color:' +
      COL.primary +
      '}' +
      '.nb-sub__sync--spin{animation:nb-sub-spin 0.7s linear infinite;transform-origin:50% 50%}' +
      '.nb-sub--card-pending + .nb-sub-overlay .upcart-public-component-product-tile__subscription-upgrade-btn,' +
      '.nb-sub--card-pending + .nb-sub-overlay .upcart-internal-component-product-tile__subscription-upgrade-btn,' +
      '.nb-sub--card-pending .upcart-public-component-product-tile__subscription-upgrade-btn,' +
      '.nb-sub--card-pending .upcart-internal-component-product-tile__subscription-upgrade-btn{' +
      'opacity:.66!important;pointer-events:none!important}' +
      '.nb-sub--ready.nb-sub--has-btn.upcart-public-component-product-tile__subscription-upgrade,' +
      '.nb-sub--ready.nb-sub--has-btn.upcart-internal-component-product-tile__subscription-upgrade{' +
      'position:relative!important;min-height:56px!important;display:block!important}' +
      '.nb-sub--ready.nb-sub--has-btn .upcart-public-component-product-tile__subscription-upgrade-btn,' +
      '.nb-sub--ready.nb-sub--has-btn .upcart-internal-component-product-tile__subscription-upgrade-btn{' +
      'position:absolute!important;top:0!important;left:0!important;right:0!important;bottom:0!important;' +
      'width:100%!important;height:100%!important;min-height:56px!important;opacity:0!important;' +
      'z-index:2!important;cursor:pointer!important;margin:0!important;padding:0!important;' +
      'border:none!important;background:transparent!important;box-shadow:none!important;' +
      '-webkit-appearance:none!important;appearance:none!important}' +
      '.nb-sub__lead{display:flex;align-items:center;gap:12px;flex-shrink:0;pointer-events:none}' +
      '.nb-sub__mark{flex-shrink:0;width:20px;height:20px;display:flex;align-items:center;justify-content:center}' +
      '.nb-sub__mark-off,.nb-sub__mark-on{display:flex;align-items:center;justify-content:center}' +
      '.nb-sub__mark-on{display:none!important}' +
      '.nb-sub--selected + .nb-sub-overlay .nb-sub__mark-off,' +
      '.nb-sub--ready.nb-sub--selected .nb-sub__mark-off{display:none!important}' +
      '.nb-sub--selected + .nb-sub-overlay .nb-sub__mark-on,' +
      '.nb-sub--ready.nb-sub--selected .nb-sub__mark-on{display:flex!important}' +
      '.nb-sub__mark-svg{display:block}' +
      '.nb-sub__sync{width:16px;height:16px;flex-shrink:0;color:' +
      COL.text +
      ';pointer-events:none}' +
      '.nb-sub--selected + .nb-sub-overlay .nb-sub__sync,' +
      '.nb-sub--ready.nb-sub--selected .nb-sub__sync{color:' +
      COL.primary +
      '}' +
      '.nb-sub__mid{flex:1;min-width:0;text-align:left;pointer-events:none;display:flex;' +
      'flex-direction:column;align-items:flex-start;justify-content:flex-start;gap:0}' +
      '.nb-sub__title{display:block;margin:0;font-family:Poppins,system-ui,-apple-system,sans-serif;' +
      'font-size:14px;font-weight:500;line-height:22px;color:' +
      COL.text +
      '}' +
      '.nb-sub--selected + .nb-sub-overlay .nb-sub__title,' +
      '.nb-sub--ready.nb-sub--selected .nb-sub__title{color:' +
      COL.primary +
      '}' +
      '.nb-sub__sub{display:flex;flex-direction:column;gap:0;margin:0;max-width:100%}' +
      '.nb-sub__sub-line,.nb-sub__sub-gift{display:block;margin:0;font-family:Poppins,system-ui,-apple-system,sans-serif;font-size:12px;' +
      'font-weight:400;line-height:16px;letter-spacing:-0.5px;color:' +
      COL.subtext +
      ';overflow-wrap:break-word;max-width:100%}' +
      '.nb-sub__sub-gift:empty{display:none!important}' +
      '.nb-sub__sub-gift[hidden]{display:none!important}' +
      '.nb-sub__price{font-family:Poppins,system-ui,-apple-system,sans-serif;font-size:14px;font-weight:600;' +
      'line-height:22px;color:' +
      COL.text +
      ';white-space:nowrap;flex-shrink:0;pointer-events:none;align-self:center;margin:auto 0}' +
      '.nb-sub--selected + .nb-sub-overlay .nb-sub__price,' +
      '.nb-sub--ready.nb-sub--selected .nb-sub__price{color:' +
      COL.primary +
      '}' +
      '.nb-sub-freq{margin-top:12px;padding-left:0}' +
      '.nb-sub-freq__label{display:block;font-family:Poppins,system-ui,-apple-system,sans-serif;font-size:12px;' +
      'font-weight:500;line-height:16px;color:' +
      COL.label +
      ';margin:0 0 8px}' +
      '.nb-sub-freq--waiting{min-height:56px}' +
      '.nb-sub-freq__row{display:flex;gap:6px;flex-wrap:nowrap;align-items:stretch;width:100%}' +
      '.nb-sub-freq__row button{' +
      'flex:1 1 0;min-width:0;padding:8px 4px;border-radius:4px;border:1px solid ' +
      COL.borderCard +
      ';background:#fff;color:' +
      COL.label +
      ';font-family:Poppins,system-ui,-apple-system,sans-serif;font-size:11px !important;font-weight:500;' +
      'line-height:16px;text-align:center;cursor:pointer;font:inherit;box-sizing:border-box;white-space:nowrap}' +
      '@media (min-width:750px){.nb-sub-freq__row{gap:8px}.nb-sub-freq__row button{padding:8px 10px;font-size:12px !important}}' +
      '.nb-sub-freq__row button.is-active{background:' +
      COL.primary +
      ';border-color:' +
      COL.primary +
      ';color:#fff}' +
      '.nb-sub-freq__row button:hover:not(.is-active):not(:disabled){border-color:#b3b3b3;background:#fafafa}' +
      '.nb-sub-freq__row button:disabled{opacity:0.55;cursor:wait}' +
      '.nb-sub-freq--busy .nb-sub-freq__row button{pointer-events:none}' +
      '.nb-sub-freq__note{font-size:12px;color:' +
      COL.subtext +
      ';margin:0 0 10px}' +
      '.nb-sub-freq--waiting .nb-sub-freq__row{min-height:40px}' +
      '.nb-sub-freq__loading{display:flex;align-items:center;gap:10px;padding:12px 0;' +
      'font-size:13px;color:' +
      COL.subtext +
      ';font-weight:500}' +
      '@keyframes nb-sub-spin{to{transform:rotate(360deg)}}' +
      '.nb-sub-freq__spinner{' +
      'width:20px;height:20px;border:2px solid #e5e7eb;border-top-color:' +
      COL.primary +
      ';border-radius:50%;animation:nb-sub-spin 0.7s linear infinite;flex-shrink:0}' +
      '.nb-sub-freq__skeleton{display:flex;gap:8px;align-items:stretch;padding:2px 0 4px;min-height:36px}' +
      '.nb-sub-freq__skel-pill{flex:1;min-width:0;height:32px;border-radius:4px;background:linear-gradient(90deg,#f3f4f6,#e5e7eb,#f3f4f6);' +
      'background-size:200% 100%;animation:nb-sub-shimmer 1.2s ease-in-out infinite}' +
      '@keyframes nb-sub-shimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}' +
      '.upcart-footer.nb-upcart-footer--redesign{font-family:Poppins,system-ui,-apple-system,sans-serif}' +
      '.UpcartDesignSettings__cartAccentColor{background:transparent!important;background-color:transparent!important;background-image:none!important}' +
      '.nb-upcart-footer-trust{display:flex;flex-direction:column;align-items:center;gap:4px;' +
      'margin:8px 0 0;padding:0;width:100%;background:transparent!important}' +
      '.nb-upcart-footer-guarantee{display:flex;align-items:center;justify-content:center;gap:6px;' +
      'margin:0;padding:0 4px;background:transparent!important}' +
      '.nb-upcart-footer-guarantee svg{flex-shrink:0;display:block;width:12px;height:9px}' +
      '.nb-upcart-footer-guarantee .nb-upcart-footer-guarantee__text,' +
      '.nb-upcart-footer-guarantee > span{' +
      'color:#4A5565!important;font-family:Poppins,system-ui,-apple-system,sans-serif!important;' +
      'font-size:14px!important;font-weight:400!important;line-height:20px!important}' +
      '.nb-upcart-footer-divider{height:1px;background:#e5e7eb;margin:12px 0;width:100%}' +
      '#CartPopup [data-nb-hsa-hidden]{display:none!important}' +
      '.upcart-footer.nb-upcart-footer--redesign .upcart-internal-addons.nb-upcart-addon-card,' +
      '.upcart-footer.nb-upcart-footer--redesign .upcart-public-addons.nb-upcart-addon-card,' +
      '#CartPopup .upcart-footer .upcart-internal-addons,' +
      '#CartPopup .upcart-footer .upcart-public-addons{' +
      'display:flex!important;flex-direction:row!important;align-items:flex-start!important;gap:12px!important;' +
      'padding:12px!important;border-radius:10px!important;background:#EFF6FF!important;box-sizing:border-box!important;' +
      'margin-top:0!important;margin-bottom:0!important;overflow:visible!important;max-height:none!important}' +
      '@media (min-width:750px){' +
      '#CartPopup .upcart-footer .upcart-internal-addons,#CartPopup .upcart-footer .upcart-public-addons{' +
      'padding:20px!important}}' +
      '.nb-upcart-addon-card .upcart-internal-addons__image-wrapper,' +
      '.nb-upcart-addon-card .upcart-public-addons__image-wrapper{' +
      'display:flex!important;align-items:center!important;justify-content:center!important;' +
      'width:40px!important;height:40px!important;flex-shrink:0!important;margin:0!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__image-wrapper svg,' +
      '.nb-upcart-addon-card .upcart-public-addons__image-wrapper svg{' +
      'stroke:unset!important;width:40px!important;height:40px!important;display:block}' +
      '.nb-upcart-addon-card .upcart-internal-addons__image-wrapper img,' +
      '.nb-upcart-addon-card .upcart-public-addons__image-wrapper img{display:none!important}' +
      '.nb-upcart-addon-shield{display:block;width:40px;height:40px;flex-shrink:0}' +
      '.nb-upcart-addon-card .upcart-internal-addons__content-wrapper,' +
      '.nb-upcart-addon-card .upcart-public-addons__content-wrapper,' +
      '#CartPopup .upcart-footer .upcart-internal-addons__content-wrapper,' +
      '#CartPopup .upcart-footer .upcart-public-addons__content-wrapper{' +
      'display:flex!important;flex-direction:column!important;align-items:stretch!important;justify-content:flex-start!important;' +
      'flex:1 1 auto!important;min-width:0!important;width:100%!important;overflow:visible!important;max-height:none!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__content-title-wrapper,' +
      '.nb-upcart-addon-card .upcart-public-addons__content-title-wrapper,' +
      '#CartPopup .upcart-footer .upcart-internal-addons__content-title-wrapper,' +
      '#CartPopup .upcart-footer .upcart-public-addons__content-title-wrapper{' +
      'display:flex!important;flex-direction:row!important;align-items:center!important;flex-wrap:nowrap!important;' +
      'gap:8px!important;width:100%!important;max-width:100%!important;flex:0 0 auto!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__content-title,' +
      '.nb-upcart-addon-card .upcart-public-addons__content-title{' +
      'flex:1 1 auto!important;min-width:0!important;margin:0!important;' +
      'color:#000!important;font-size:14px!important;font-weight:500!important;line-height:22px!important;font-family:Poppins,system-ui,-apple-system,sans-serif!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__content-price__row,' +
      '.nb-upcart-addon-card .upcart-public-addons__content-price__row,' +
      '.nb-upcart-addon-card .upcart-internal-addons__content-price,' +
      '.nb-upcart-addon-card .upcart-public-addons__content-price{' +
      'display:flex!important;align-items:center!important;flex-shrink:0!important;margin:0!important;gap:8px!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__price,' +
      '.nb-upcart-addon-card .upcart-public-addons__price,' +
      '.nb-upcart-addon-card [data-upcart-chunk="addon-price"]{' +
      'color:#000!important;font-size:14px!important;font-weight:500!important;line-height:22px!important;font-family:Poppins,system-ui,-apple-system,sans-serif!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__content-description,' +
      '.nb-upcart-addon-card .upcart-public-addons__content-description,' +
      '#CartPopup .upcart-internal-addons__content-description,' +
      '#CartPopup .upcart-public-addons__content-description,' +
      '#CartPopup .upcart-footer [data-upcart-chunk="addon-description"],' +
      '#CartPopup .upcart-footer .upcart-internal-addons__content-description,' +
      '#CartPopup .upcart-footer .upcart-public-addons__content-description,' +
      '.upcart-internal-addons__content-description.upcart-public-addons__content-description,' +
      '.nb-upcart-addon-desc{' +
      'display:flex!important;flex-direction:column!important;align-items:flex-start!important;' +
      'justify-content:flex-start!important;gap:2px!important;margin-top:4px!important;' +
      'width:100%!important;max-width:100%!important;flex:0 0 auto!important;align-self:stretch!important;' +
      'height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important;' +
      'white-space:normal!important;word-wrap:break-word!important;overflow-wrap:break-word!important;' +
      'text-overflow:clip!important;line-clamp:unset!important;-webkit-line-clamp:unset!important;' +
      '-webkit-box-orient:unset!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__content-description p,' +
      '.nb-upcart-addon-card .upcart-public-addons__content-description p,' +
      '#CartPopup .upcart-internal-addons__content-description p,' +
      '#CartPopup .upcart-public-addons__content-description p,' +
      '#CartPopup .upcart-footer [data-upcart-chunk="addon-description"] p,' +
      '#CartPopup .upcart-footer .upcart-internal-addons__content-description p,' +
      '#CartPopup .upcart-footer .upcart-public-addons__content-description p,' +
      '.upcart-internal-addons__content-description.upcart-public-addons__content-description p,' +
      '.nb-upcart-addon-desc p{' +
      'display:block!important;margin:0!important;padding:0!important;background:transparent!important;' +
      'color:#4A5565!important;font-size:12px!important;font-weight:400!important;line-height:16px!important;' +
      'font-family:Poppins,system-ui,-apple-system,sans-serif!important;height:auto!important;' +
      'min-height:0!important;max-height:none!important;overflow:visible!important;white-space:normal!important;' +
      'word-wrap:break-word!important;overflow-wrap:break-word!important;text-overflow:clip!important;' +
      'line-clamp:unset!important;-webkit-line-clamp:unset!important;-webkit-box-orient:unset!important}' +
      '.nb-upcart-addon-card .upcart-internal-addons__toggle-wrapper,' +
      '.nb-upcart-addon-card .upcart-public-addons__toggle-wrapper{' +
      'flex-shrink:0!important;margin:0!important;margin-inline-start:0!important}' +
      'select.nb-sub-native-select{' +
      'position:absolute!important;width:1px!important;height:1px!important;' +
      'opacity:0!important;pointer-events:none!important;clip:rect(0,0,0,0)!important;' +
      'border:0!important;padding:0!important;margin:0!important}' +
      '#CartPopup [data-upcart-chunk="header-title-content"]{' +
      'color:#121212!important;font-family:Poppins,system-ui,-apple-system,sans-serif!important;' +
      'font-size:28px!important;font-style:normal!important;font-weight:700!important;' +
      'line-height:36.4px!important;letter-spacing:0.6px!important;margin:0!important}' +
      '#CartPopup .upcart-public-upsell__title,#CartPopup .upcart-internal-upsell__title,#CartPopup [data-upcart-chunk="upsell-title"],' +
      '#CartPopup .upcart-internal-upsell .upcart-internal-style__title-large,#CartPopup .upcart-internal-upsell .upcart-internal-style__title{' +
      'text-align:left!important;width:100%!important;padding:0!important;margin-bottom:16px!important}' +
      '#CartPopup .upcart-public-upsell__title p,#CartPopup .upcart-internal-upsell__title p,#CartPopup [data-upcart-chunk="upsell-title"] p{' +
      'color:#000!important;font-family:Poppins,system-ui,-apple-system,sans-serif!important;' +
      'font-size:14px!important;font-style:normal!important;font-weight:600!important;line-height:20px!important;' +
      'text-align:left!important;margin:0!important;padding:0!important}' +
      '#CartPopup [class*="styles_Footer__"].upcart-footer,#CartPopup .upcart-footer{' +
      'box-sizing:border-box!important;padding:12px 16px 16px!important;flex:0 0 auto!important}' +
      '@media (min-width:750px){#CartPopup [class*="styles_Footer__"].upcart-footer,#CartPopup .upcart-footer{' +
      'padding:20px!important}}' +
      '#CartPopup .upcart-internal-cart-preview__container,' +
      '#CartPopup .upcart-cart[data-scrollable],' +
      '#CartPopup .upcart-cart{' +
      'display:flex!important;flex-direction:column!important;max-height:100%!important;height:100%!important;' +
      'min-height:0!important}' +
      '#CartPopup .upcart-cart-body,' +
      '#CartPopup [class*="CartPreview__body"]{' +
      'flex:1 1 auto!important;min-height:0!important;overflow-x:hidden!important;overflow-y:auto!important;' +
      '-webkit-overflow-scrolling:touch!important}' +
      '#CartPopup .upcart-internal-upsell,#CartPopup .upcart-public-upsell,' +
      '#CartPopup [class*="bottomModules"]{' +
      'display:block!important;visibility:visible!important;opacity:1!important;' +
      'height:auto!important;max-height:none!important;overflow:visible!important;' +
      'box-sizing:border-box!important;padding:12px 16px 16px!important}' +
      '@media (min-width:750px){#CartPopup .upcart-internal-upsell,#CartPopup .upcart-public-upsell{' +
      'padding:20px 16px!important}}' +
      '#CartPopup .upcart-footer #upcart-express-payments,' +
      '#CartPopup .upcart-footer .upcart-public-express-payments__container,' +
      '#CartPopup .upcart-footer .upcart-internal-express-payments__container{' +
      'margin:0!important;margin-bottom:0!important;margin-block-end:0!important;' +
      'padding-bottom:0!important}' +
      '#CartPopup .upcart-footer #upcart-express-payments .dynamic-checkout__content,' +
      '#CartPopup .upcart-footer #dynamic-checkout-cart,' +
      '#CartPopup .upcart-footer #dynamic-checkout-cart ul,' +
      '#CartPopup .upcart-footer #dynamic-checkout-cart li{' +
      'margin:0!important;margin-bottom:0!important;margin-block-end:0!important}' +
      '#CartPopup .upcart-internal-upsell__vertical-layout-wrapper,#CartPopup .upcart-public-upsell__vertical-layout-wrapper{' +
      'padding:0!important}' +
      '#CartPopup .upcart-public-component-upsell-tile.nb-upcart-upsell-tile--ready,' +
      '#CartPopup .upcart-internal-component-upsell-tile.nb-upcart-upsell-tile--ready{' +
      'display:flex!important;padding:12px!important;align-items:center!important;gap:0!important;' +
      'align-self:stretch!important;border-radius:4px!important;background:#F6F6F7!important;' +
      'box-sizing:border-box!important;width:100%!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready>a[href]{' +
      'flex-shrink:0!important;margin:0 12px 0 0!important;text-decoration:none!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__image-container,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__image-container{' +
      'width:64px!important;height:64px!important;flex-shrink:0!important;margin:0!important;' +
      'display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__image,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__image{' +
      'width:64px!important;height:64px!important;border-radius:2px!important;object-fit:cover!important;' +
      'display:block!important;max-width:none!important;max-height:none!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__info,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__info{' +
      'flex:1!important;min-width:0!important;display:flex!important;flex-direction:column!important;' +
      'align-items:flex-start!important;gap:4px!important;margin:0 4px 0 0!important;padding:0!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__title-link,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__title-link{' +
      'margin:0!important;padding:0!important;text-decoration:none!important;width:100%!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__title,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__title{' +
      'margin:0!important;padding:0!important;color:#000!important;' +
      'font-family:Poppins,system-ui,-apple-system,sans-serif!important;font-size:14px!important;' +
      'font-weight:500!important;line-height:22px!important;text-align:left!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__price-row,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__price-row{' +
      'display:flex!important;align-items:center!important;gap:4px!important;align-self:stretch!important;' +
      'margin:0!important;padding:0!important;width:100%!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__price-compare-at,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__price-compare-at{' +
      'color:#99A1AF!important;font-family:Poppins,system-ui,-apple-system,sans-serif!important;' +
      'font-size:12px!important;font-weight:400!important;line-height:16px!important;' +
      'text-decoration-line:line-through!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component-upsell-tile__price,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component-upsell-tile__price{' +
      'color:#000!important;font-family:Poppins,system-ui,-apple-system,sans-serif!important;' +
      'font-size:14px!important;font-weight:600!important;line-height:22px!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready>.upcart-public-component-upsell-tile__variant-row,' +
      '#CartPopup .nb-upcart-upsell-tile--ready>.upcart-internal-component-upsell-tile__variant-row{' +
      'flex-shrink:0!important;margin:0!important;padding:0!important;display:flex!important;' +
      'align-items:center!important;align-self:center!important;gap:0!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .nb-upcart-upsell-tile__variant-select{' +
      'width:100%!important;align-self:stretch!important;margin:0!important;padding:0!important;' +
      'box-sizing:border-box!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .nb-upcart-upsell-tile__variant-select select{' +
      'width:100%!important;max-width:100%!important;box-sizing:border-box!important;' +
      'font-family:Poppins,system-ui,-apple-system,sans-serif!important;font-size:12px!important;' +
      'font-weight:400!important;line-height:16px!important;color:#000!important;' +
      'padding:6px 8px!important;border:1px solid #CCCCCC!important;border-radius:4px!important;' +
      'background:#fff!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component__button,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component__button{' +
      'display:flex!important;padding:4px 16px!important;justify-content:center!important;' +
      'align-items:center!important;gap:6px!important;border-radius:4px!important;' +
      'background:#4397F6!important;background-image:none!important;color:#FFF!important;' +
      'font-family:Poppins,system-ui,-apple-system,sans-serif!important;font-size:14px!important;' +
      'font-weight:600!important;line-height:22px!important;text-align:center!important;' +
      'border:none!important;box-shadow:none!important;white-space:nowrap!important;' +
      'min-width:auto!important;width:auto!important;height:auto!important;cursor:pointer!important;' +
      '-webkit-appearance:none!important;appearance:none!important}' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-public-component__button:hover,' +
      '#CartPopup .nb-upcart-upsell-tile--ready .upcart-internal-component__button:hover{' +
      'background:#4397F6!important;background-image:none!important;color:#FFF!important}' +
      '#CartPopup .upcart-public-upsell__vertical-layout-wrapper>div+div,' +
      '#CartPopup .upcart-internal-upsell__vertical-layout-wrapper>div+div{' +
      'margin-top:8px!important}' +
      /* NB-014-AB — hide subscribe / frequency in cart drawer (PDP unchanged) */
      '#CartPopup .upcart-public-component-product-tile__subscription-upgrade,' +
      '#CartPopup .upcart-internal-component-product-tile__subscription-upgrade,' +
      '#CartPopup .nb-sub-overlay,' +
      '#CartPopup .nb-sub-freq,' +
      '#CartPopup .upcart-public-product-properties__subscription,' +
      '#CartPopup .upcart-internal-product-properties__subscription{' +
      'display:none!important;min-height:0!important;height:0!important;margin:0!important;' +
      'padding:0!important;overflow:hidden!important;border:none!important;pointer-events:none!important}' +
      /* NB-014-AB — free gift line items */
      '#CartPopup .nb-upcart-gift-tile .upcart-public-component-product-tile__quantity,' +
      '#CartPopup .nb-upcart-gift-tile .upcart-internal-component-product-tile__quantity,' +
      '#CartPopup .nb-upcart-gift-tile [class*="quantity-selector"],' +
      '#CartPopup .nb-upcart-gift-tile [class*="QuantitySelector"],' +
      '#CartPopup .nb-upcart-gift-tile [data-upcart-chunk="cart-item-quantity"],' +
      '#CartPopup .nb-upcart-gift-tile [data-upcart-chunk="cart-item-price"],' +
      '#CartPopup .nb-upcart-gift-tile [data-upcart-chunk="cart-item-compare-at-price"],' +
      '#CartPopup .nb-upcart-gift-tile [data-upcart-chunk="cart-item-savings"]{' +
      'display:none!important}' +
      '#CartPopup .nb-upcart-gift-price{' +
      'display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin:0;padding:0;' +
      'font-family:Poppins,system-ui,-apple-system,sans-serif}' +
      '#CartPopup .nb-upcart-gift-price__was{' +
      'color:#99A1AF;font-size:12px;font-weight:400;line-height:16px;text-decoration:line-through}' +
      '#CartPopup .nb-upcart-gift-price__free{' +
      'color:#000;font-size:14px;font-weight:600;line-height:22px}' +
      '#CartPopup .nb-upcart-gift-price__save{' +
      'color:#16A34A;font-size:12px;font-weight:500;line-height:16px}' +
      '@media (min-width:750px){' +
      '#CartPopup .nb-upcart-gift-price__was{font-size:12px}' +
      '#CartPopup .nb-upcart-gift-price__free{font-size:14px}' +
      '#CartPopup .nb-upcart-gift-price__save{font-size:12px}' +
      '}';

    document.head.appendChild(el);
  }

  function syncIconSvg() {
    return (
      '<svg class="nb-sub__sync" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.67737 2.00631 11.2874 2.66082 12.4933 3.82667L14 5.33333" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M14.0001 2V5.33333H10.6667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14C6.32263 13.9937 4.71265 13.3392 3.50667 12.1733L2 10.6667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M5.33333 10.6667H2V14" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>'
    );
  }

  function markLeadInnerHtml() {
    return (
      '<span class="nb-sub__mark" aria-hidden="true">' +
      '<span class="nb-sub__mark-off">' +
      '<svg class="nb-sub__mark-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="0.6" y="0.6" width="18.8" height="18.8" rx="9.4" stroke="#CCCCCC" stroke-width="1.2"/>' +
      '</svg></span>' +
      '<span class="nb-sub__mark-on">' +
      '<svg class="nb-sub__mark-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="10" cy="10" r="10" fill="#1699F8"/>' +
      '<path d="M14 7L8.5 12.5L6 10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
      '</svg></span>' +
      '</span>'
    );
  }

  function footerShieldSvg() {
    return (
      '<svg class="nb-upcart-addon-shield" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z" fill="#D2E9F9"/>' +
      '<path d="M26.6666 20.8334C26.6666 25 23.7499 27.0834 20.2833 28.2917C20.1017 28.3532 19.9045 28.3503 19.7249 28.2834C16.2499 27.0834 13.3333 25 13.3333 20.8334V15C13.3333 14.779 13.421 14.5671 13.5773 14.4108C13.7336 14.2545 13.9456 14.1667 14.1666 14.1667C15.8333 14.1667 17.9166 13.1667 19.3666 11.9C19.5431 11.7492 19.7677 11.6663 19.9999 11.6663C20.2321 11.6663 20.4567 11.7492 20.6333 11.9C22.0916 13.175 24.1666 14.1667 25.8333 14.1667C26.0543 14.1667 26.2662 14.2545 26.4225 14.4108C26.5788 14.5671 26.6666 14.779 26.6666 15V20.8334Z" stroke="#1699F8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>'
    );
  }

  function footerGuaranteeTickSvg() {
    return (
      '<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M11.3334 0.666687L4.00008 8.00002L0.666748 4.66669" stroke="#00A63E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>'
    );
  }

  function reorderNbUpcartFooter(footer) {
    var summary = footer.querySelector('.upcart-internal-cart-summary');
    var skel = footer.querySelector('.upcart-checkout-button-container-skeleton');
    var checkout = footer.querySelector('.styles_Footer__checkoutButton__');
    var trust = footer.querySelector('.nb-upcart-footer-trust');
    var guarantee = footer.querySelector('.nb-upcart-footer-guarantee');
    var divider = footer.querySelector('.nb-upcart-footer-divider');
    var addons =
      footer.querySelector('.upcart-internal-addons') ||
      footer.querySelector('.upcart-public-addons');
    var express = footer.querySelector('#upcart-express-payments');
    var nodes = [summary, skel, checkout, trust || guarantee, divider, addons, express];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i]) footer.appendChild(nodes[i]);
    }
  }

  var NB_ADDON_BENEFITS = ['Coverage for loss, theft, or damage during shipping'];

  function isAddonDescriptionFormatted(desc) {
    if (!desc) return false;
    var ps = desc.querySelectorAll('p');
    if (ps.length !== NB_ADDON_BENEFITS.length) return false;
    for (var i = 0; i < NB_ADDON_BENEFITS.length; i++) {
      if ((ps[i].textContent || '').trim() !== NB_ADDON_BENEFITS[i]) return false;
    }
    return true;
  }

  function applyAddonLayoutStyles(addons) {
    if (!addons) return;
    addons.style.setProperty('display', 'flex', 'important');
    addons.style.setProperty('flex-direction', 'row', 'important');
    addons.style.setProperty('align-items', 'flex-start', 'important');
    addons.style.setProperty('overflow', 'visible', 'important');
    addons.style.setProperty('max-height', 'none', 'important');
    var contentWrap =
      addons.querySelector('.upcart-internal-addons__content-wrapper') ||
      addons.querySelector('.upcart-public-addons__content-wrapper');
    var titleWrap =
      addons.querySelector('.upcart-internal-addons__content-title-wrapper') ||
      addons.querySelector('.upcart-public-addons__content-title-wrapper');
    if (contentWrap) {
      contentWrap.style.setProperty('display', 'flex', 'important');
      contentWrap.style.setProperty('flex-direction', 'column', 'important');
      contentWrap.style.setProperty('align-items', 'stretch', 'important');
      contentWrap.style.setProperty('flex', '1 1 auto', 'important');
      contentWrap.style.setProperty('min-width', '0', 'important');
      contentWrap.style.setProperty('width', '100%', 'important');
      contentWrap.style.setProperty('overflow', 'visible', 'important');
      contentWrap.style.setProperty('max-height', 'none', 'important');
    }
    if (titleWrap) {
      titleWrap.style.setProperty('display', 'flex', 'important');
      titleWrap.style.setProperty('flex-direction', 'row', 'important');
      titleWrap.style.setProperty('align-items', 'center', 'important');
      titleWrap.style.setProperty('flex-wrap', 'nowrap', 'important');
      titleWrap.style.setProperty('width', '100%', 'important');
      titleWrap.style.setProperty('flex', '0 0 auto', 'important');
    }
  }

  function applyAddonDescriptionStyles(desc) {
    if (!desc) return;
    desc.classList.add('nb-upcart-addon-desc');
    desc.style.setProperty('display', 'flex', 'important');
    desc.style.setProperty('flex-direction', 'column', 'important');
    desc.style.setProperty('align-items', 'flex-start', 'important');
    desc.style.setProperty('justify-content', 'flex-start', 'important');
    desc.style.setProperty('gap', '2px', 'important');
    desc.style.setProperty('flex', '0 0 auto', 'important');
    desc.style.setProperty('align-self', 'stretch', 'important');
    desc.style.setProperty('width', '100%', 'important');
    desc.style.setProperty('max-width', '100%', 'important');
    desc.style.setProperty('height', 'auto', 'important');
    desc.style.setProperty('min-height', '0', 'important');
    desc.style.setProperty('max-height', 'none', 'important');
    desc.style.setProperty('overflow', 'visible', 'important');
    desc.style.setProperty('white-space', 'normal', 'important');
    desc.style.setProperty('word-wrap', 'break-word', 'important');
    desc.style.setProperty('overflow-wrap', 'break-word', 'important');
    desc.style.setProperty('text-overflow', 'clip', 'important');
    desc.style.setProperty('line-clamp', 'unset', 'important');
    desc.style.setProperty('-webkit-line-clamp', 'unset', 'important');
    desc.style.setProperty('-webkit-box-orient', 'unset', 'important');
    var ps = desc.querySelectorAll('p');
    for (var k = 0; k < ps.length; k++) {
      ps[k].style.setProperty('display', 'block', 'important');
      ps[k].style.setProperty('height', 'auto', 'important');
      ps[k].style.setProperty('max-height', 'none', 'important');
      ps[k].style.setProperty('overflow', 'visible', 'important');
      ps[k].style.setProperty('white-space', 'normal', 'important');
      ps[k].style.setProperty('text-overflow', 'clip', 'important');
      ps[k].style.setProperty('line-clamp', 'unset', 'important');
      ps[k].style.setProperty('-webkit-line-clamp', 'unset', 'important');
      ps[k].style.setProperty('-webkit-box-orient', 'unset', 'important');
    }
  }

  function formatAddonDescription(desc) {
    if (!desc) return;
    var html = '';
    for (var j = 0; j < NB_ADDON_BENEFITS.length; j++) {
      html += '<p>' + NB_ADDON_BENEFITS[j] + '</p>';
    }
    desc.innerHTML = html;
    desc.setAttribute('data-nb-addon-desc-ready', '1');
    applyAddonDescriptionStyles(desc);
  }

  function relocateAddonDescription(addons) {
    var contentWrap =
      addons.querySelector('.upcart-internal-addons__content-wrapper') ||
      addons.querySelector('.upcart-public-addons__content-wrapper');
    var titleWrap =
      addons.querySelector('.upcart-internal-addons__content-title-wrapper') ||
      addons.querySelector('.upcart-public-addons__content-title-wrapper');
    var desc =
      addons.querySelector('[data-upcart-chunk="addon-description"]') ||
      addons.querySelector('.upcart-internal-addons__content-description') ||
      addons.querySelector('.upcart-public-addons__content-description');
    if (!contentWrap || !desc) return;
    if (titleWrap && desc.parentElement === titleWrap) {
      titleWrap.insertAdjacentElement('afterend', desc);
      return;
    }
    if (desc.parentElement !== contentWrap && titleWrap && titleWrap.parentElement === contentWrap) {
      titleWrap.insertAdjacentElement('afterend', desc);
    }
  }

  function relocateAddonToggle(addons) {
    var titleWrap =
      addons.querySelector('.upcart-internal-addons__content-title-wrapper') ||
      addons.querySelector('.upcart-public-addons__content-title-wrapper');
    var toggleWrap =
      addons.querySelector('.upcart-internal-addons__toggle-wrapper') ||
      addons.querySelector('.upcart-public-addons__toggle-wrapper');
    if (!titleWrap || !toggleWrap) return;
    var priceRow =
      titleWrap.querySelector('.upcart-internal-addons__content-price__row') ||
      titleWrap.querySelector('.upcart-public-addons__content-price__row');
    var priceEl =
      priceRow ||
      titleWrap.querySelector('.upcart-internal-addons__content-price') ||
      titleWrap.querySelector('.upcart-public-addons__content-price');
    if (priceEl && toggleWrap.parentElement !== titleWrap) {
      priceEl.insertAdjacentElement('afterend', toggleWrap);
      return;
    }
    if (!priceEl && toggleWrap.parentElement !== titleWrap) {
      titleWrap.appendChild(toggleWrap);
      return;
    }
    if (toggleWrap.parentElement === titleWrap && priceEl && toggleWrap.previousElementSibling !== priceEl) {
      priceEl.insertAdjacentElement('afterend', toggleWrap);
    }
  }

  function resetExpressPaymentsMargin(footer) {
    if (!footer) return;
    var express = footer.querySelector('#upcart-express-payments');
    if (!express) return;

    express.style.setProperty('margin', '0', 'important');
    express.style.setProperty('margin-bottom', '0', 'important');
    express.style.setProperty('margin-block-end', '0', 'important');
    express.style.setProperty('padding-bottom', '0', 'important');

    var nodes = express.querySelectorAll('.dynamic-checkout__content, #dynamic-checkout-cart, ul, li');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.setProperty('margin', '0', 'important');
      nodes[i].style.setProperty('margin-bottom', '0', 'important');
      nodes[i].style.setProperty('margin-block-end', '0', 'important');
    }
  }

  var NB_SECURE_CHECKOUT_LABEL = 'Secure Checkout';
  var checkoutLabelObserver = null;
  var checkoutLabelObservedEl = null;
  var nbCheckoutRelabeling = false;

  function applySecureCheckoutLabel(btn) {
    if (!btn) return;
    var txt = (btn.textContent || '').replace(/\s+/g, ' ').trim();
    if (!txt) return;
    var labeled = txt.replace(/^Checkout\b/i, NB_SECURE_CHECKOUT_LABEL);
    btn.setAttribute('aria-label', labeled);
    if (/^Secure Checkout\b/i.test(txt)) return;
    if (!/^Checkout\b/i.test(txt)) return;
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
    var node;
    var replaced = false;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (!value || !/Checkout\b/i.test(value) || /Secure Checkout\b/i.test(value)) continue;
      node.nodeValue = value.replace(/^(\s*)Checkout\b/i, '$1' + NB_SECURE_CHECKOUT_LABEL);
      replaced = true;
      break;
    }
    if (!replaced) btn.textContent = labeled;
  }

  function relabelSecureCheckoutButtons() {
    if (nbCheckoutRelabeling) return;
    nbCheckoutRelabeling = true;
    try {
      var nodes = document.querySelectorAll(
        '#CartPopup a.upcart-checkout-button, .upcart-footer a.upcart-checkout-button'
      );
      for (var i = 0; i < nodes.length; i++) applySecureCheckoutLabel(nodes[i]);
    } finally {
      nbCheckoutRelabeling = false;
    }
  }

  function ensureCheckoutLabelObserver() {
    var root = document.getElementById('CartPopup') || document.body;
    if (!root) return;
    if (checkoutLabelObserver && checkoutLabelObservedEl === root) return;
    if (checkoutLabelObserver) checkoutLabelObserver.disconnect();
    checkoutLabelObservedEl = root;
    checkoutLabelObserver = new MutationObserver(function () {
      var popup = document.getElementById('CartPopup');
      if (popup && checkoutLabelObservedEl !== popup) {
        ensureCheckoutLabelObserver();
        return;
      }
      relabelSecureCheckoutButtons();
    });
    checkoutLabelObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    relabelSecureCheckoutButtons();
  }

  function enhanceUpcartFooter() {
    var footer =
      document.querySelector('.upcart-footer') ||
      document.querySelector('.styles_Footer__.upcart-footer') ||
      document.querySelector('[class*="styles_Footer__"].upcart-footer');
    if (!footer) return;

    footer.classList.add('nb-upcart-footer--redesign');
    ensureCheckoutLabelObserver();
    relabelSecureCheckoutButtons();

    var checkoutWrap = footer.querySelector('.styles_Footer__checkoutButton__');
    syncFooterTrustLines(footer, checkoutWrap);

    if (!footer.querySelector('.nb-upcart-footer-divider')) {
      var divBar = document.createElement('div');
      divBar.className = 'nb-upcart-footer-divider';
      divBar.setAttribute('role', 'presentation');
      var anchor = footer.querySelector('.nb-upcart-footer-trust') || checkoutWrap;
      if (anchor) anchor.insertAdjacentElement('afterend', divBar);
    }

    var addons =
      footer.querySelector('.upcart-internal-addons') ||
      footer.querySelector('.upcart-public-addons');
    if (addons) {
      addons.classList.add('nb-upcart-addon-card');
      var imgWrap =
        addons.querySelector('.upcart-internal-addons__image-wrapper') ||
        addons.querySelector('.upcart-public-addons__image-wrapper');
      if (imgWrap && !imgWrap.querySelector('.nb-upcart-addon-shield')) {
        imgWrap.innerHTML = footerShieldSvg();
      }
      relocateAddonDescription(addons);
      applyAddonLayoutStyles(addons);
      var desc =
        addons.querySelector('[data-upcart-chunk="addon-description"]') ||
        addons.querySelector('.upcart-internal-addons__content-description') ||
        addons.querySelector('.upcart-public-addons__content-description');
      if (desc && !isAddonDescriptionFormatted(desc)) {
        formatAddonDescription(desc);
      } else if (desc) {
        applyAddonDescriptionStyles(desc);
      }
      relocateAddonToggle(addons);
    }

    reorderNbUpcartFooter(footer);
    resetExpressPaymentsMargin(footer);
    restoreBottomModulesInCartBody();
  }

  function paintTrustRow(row, text) {
    if (!row) return;
    row.className = 'nb-upcart-footer-guarantee';
    row.innerHTML =
      footerGuaranteeTickSvg() +
      '<span class="nb-upcart-footer-guarantee__text">' +
      text +
      '</span>';
  }

  function findHsaTrustSource(root) {
    if (!root) return null;
    var nodes = root.querySelectorAll('div, p, span, a, li');
    var best = null;
    var bestLen = 999;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest && el.closest('.nb-upcart-footer-trust')) continue;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 100) continue;
      if (!/HSA\/FSA/i.test(t) || !/eligible/i.test(t)) continue;
      if (t.length < bestLen) {
        best = el;
        bestLen = t.length;
      }
    }
    return best;
  }

  function hideNativeHsaTrust(source) {
    if (!source || source.closest && source.closest('.nb-upcart-footer-trust')) return;
    var hide = source;
    var parent = source.parentElement;
    if (
      parent &&
      parent !== source.closest('.upcart-footer') &&
      (parent.textContent || '').replace(/\s+/g, ' ').trim().length <= 110
    ) {
      hide = parent;
    }
    hide.setAttribute('data-nb-hsa-hidden', '1');
    hide.style.setProperty('display', 'none', 'important');
  }

  function syncFooterTrustLines(footer, checkoutWrap) {
    if (!footer) return;
    var stack = footer.querySelector('.nb-upcart-footer-trust');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'nb-upcart-footer-trust';
      if (checkoutWrap) checkoutWrap.insertAdjacentElement('afterend', stack);
      else footer.appendChild(stack);
    }

    var looseGuar = footer.querySelector('.nb-upcart-footer-guarantee');
    if (looseGuar && !stack.contains(looseGuar)) stack.appendChild(looseGuar);

    var hsaSource = findHsaTrustSource(footer) || findHsaTrustSource(cartRoot());
    if (hsaSource) {
      ensureTrustRow(stack, 'hsa', 'HSA/FSA eligible for qualified customers.', true);
      hideNativeHsaTrust(hsaSource);
    }

    ensureTrustRow(stack, 'guarantee', '30-day money-back guarantee.', false);
  }

  function ensureTrustRow(stack, key, text, prepend) {
    var row = stack.querySelector('[data-nb-trust="' + key + '"]');
    if (!row) {
      row =
        key === 'guarantee'
          ? stack.querySelector('.nb-upcart-footer-guarantee:not([data-nb-trust])')
          : null;
      if (!row) row = document.createElement('div');
      row.setAttribute('data-nb-trust', key);
      if (prepend && stack.firstChild) stack.insertBefore(row, stack.firstChild);
      else stack.appendChild(row);
    }
    var label = row.querySelector('.nb-upcart-footer-guarantee__text');
    var svg = row.querySelector('svg');
    if (
      !label ||
      label.textContent !== text ||
      !svg ||
      svg.getAttribute('viewBox') !== '0 0 12 9'
    ) {
      paintTrustRow(row, text);
    }
    return row;
  }

  /* NB-014-AB — keep upsells in scroll body below line items */
  function restoreBottomModulesInCartBody() {
    var cart = cartRoot();
    if (!cart) return;

    var cartBody =
      cart.querySelector('.upcart-cart-body') ||
      cart.querySelector('[class*="CartPreview__body"]');
    if (!cartBody) return;

    var items =
      cart.querySelector('.upcart-internal-cart-items') ||
      cart.querySelector('.upcart-public-cart-items');

    var bottomModules =
      cart.querySelector('[class*="styles_CartPreview__bottomModules__"]') ||
      cart.querySelector('[class*="bottomModules"]');

    var upsell =
      cart.querySelector('.upcart-internal-upsell') ||
      cart.querySelector('.upcart-public-upsell');

    if (bottomModules && !cartBody.contains(bottomModules)) {
      if (items && items.parentNode === cartBody) {
        items.insertAdjacentElement('afterend', bottomModules);
      } else {
        cartBody.appendChild(bottomModules);
      }
    }

    if (!upsell) return;

    var alreadyAfterItems =
      items && (upsell === items.nextElementSibling || (bottomModules && bottomModules.contains(upsell)));
    if (cartBody.contains(upsell) && alreadyAfterItems) return;

    if (bottomModules && cartBody.contains(bottomModules) && !bottomModules.contains(upsell)) {
      bottomModules.appendChild(upsell);
      return;
    }
    if (items && items.parentNode) {
      items.insertAdjacentElement('afterend', upsell);
      return;
    }
    if (!cartBody.contains(upsell)) cartBody.appendChild(upsell);
  }

  /* NB-005-All-CartDrawer-CVR-AB */
  function enhanceUpsellTiles() {
    var cart = cartRoot();
    if (!cart) return;

    var tiles = cart.querySelectorAll(
      '.upcart-public-component-upsell-tile,.upcart-internal-component-upsell-tile'
    );
    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      var info =
        tile.querySelector('.upcart-public-component-upsell-tile__info') ||
        tile.querySelector('.upcart-internal-component-upsell-tile__info');
      var variantRow =
        tile.querySelector('.upcart-public-component-upsell-tile__variant-row') ||
        tile.querySelector('.upcart-internal-component-upsell-tile__variant-row');
      var priceRow =
        info &&
        (info.querySelector('.upcart-public-component-upsell-tile__price-row') ||
          info.querySelector('.upcart-internal-component-upsell-tile__price-row'));

      if (info && variantRow) {
        var select = variantRow.querySelector('select');
        if (select) {
          var selectHost = info.querySelector('.nb-upcart-upsell-tile__variant-select');
          if (!selectHost) {
            selectHost = document.createElement('div');
            selectHost.className = 'nb-upcart-upsell-tile__variant-select';
            if (priceRow) {
              if (priceRow.nextSibling) {
                info.insertBefore(selectHost, priceRow.nextSibling);
              } else {
                info.appendChild(selectHost);
              }
            } else {
              info.appendChild(selectHost);
            }
          }
          if (select.parentElement !== selectHost) {
            selectHost.appendChild(select);
          }
        }

        if (variantRow.parentElement !== tile) {
          tile.appendChild(variantRow);
        }
      }

      if (variantRow) {
        var btn =
          variantRow.querySelector('.upcart-public-component__button') ||
          variantRow.querySelector('.upcart-internal-component__button');
        if (btn) btn.textContent = 'Add';
      }

      tile.classList.add('nb-upcart-upsell-tile--ready');
    }
  }

  /* NB-005-All-CartDrawer-CVR-AB */
  function enhanceUpsellTitle() {
    var cart = cartRoot();
    if (!cart) return;

    var want = 'Complete Your Setup';
    var titles = cart.querySelectorAll('[data-upcart-chunk="upsell-title"]');
    for (var i = 0; i < titles.length; i++) {
      var title = titles[i];
      if (title.getAttribute('data-nb-upsell-title') === want) continue;
      var p = title.querySelector('p');
      if (p) {
        p.textContent = want;
      } else {
        title.textContent = want;
      }
      title.setAttribute('data-nb-upsell-title', want);
    }
  }

  function cartRoot() {
    return (
      document.getElementById('CartPopup') ||
      document.querySelector('[id="CartPopup"]') ||
      document.querySelector('.upcart-internal-cart-preview__container') ||
      document.querySelector('div.upcart-cart[data-scrollable]') ||
      document.querySelector('div.upcart-cart.styles_CartPreview__position-fixed__')
    );
  }

  function hostFromTile(tile) {
    if (!tile) return null;
    return (
      tile.querySelector('.upcart-public-component-product-tile__subscription-upgrade') ||
      tile.querySelector('.upcart-internal-component-product-tile__subscription-upgrade')
    );
  }

  function tileFromHost(host) {
    var t =
      host.closest('.upcart-public-component-product-tile') ||
      host.closest('.upcart-internal-component-product-tile');
    if (t) return t;
    var el = host.parentElement;
    var n = 0;
    while (el && n++ < 14) {
      if (el.querySelector && el.querySelector('[data-upcart-chunk="cart-item-price"]')) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function productTitleFromTile(tile) {
    if (!tile) return '';
    var link =
      tile.querySelector('.upcart-public-component-product-tile__title-link') ||
      tile.querySelector('.upcart-internal-component-product-tile__title-link') ||
      tile.querySelector('[class*="product-title"]');
    return link ? link.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function tileIsStarterKit(tile) {
    return /starter kit/i.test(productTitleFromTile(tile));
  }

  function productHandleFromTile(tile) {
    if (!tile) return '';
    var link =
      tile.querySelector('.upcart-public-component-product-tile__title-link') ||
      tile.querySelector('.upcart-internal-component-product-tile__title-link') ||
      tile.querySelector('a[href*="/products/"]');
    if (!link || !link.href) return '';
    var m = link.href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function isLockedSubscriptionHandle(handle) {
    if (!handle) return false;
    for (var lh = 0; lh < NB_SUBSCRIPTION_LOCKED_HANDLES.length; lh++) {
      if (NB_SUBSCRIPTION_LOCKED_HANDLES[lh] === handle) return true;
    }
    return false;
  }

  function productHandleFromCartTile(tile, cart) {
    var fromLink = productHandleFromTile(tile);
    if (fromLink) return fromLink;
    var ctx = cartLineForTile(tile, cart);
    if (!ctx || !ctx.item) return '';
    if (ctx.item.handle) return String(ctx.item.handle);
    if (ctx.item.url) {
      var m = String(ctx.item.url).match(/\/products\/([^/?#]+)/);
      if (m) return decodeURIComponent(m[1]);
    }
    return '';
  }

  function parseMoneyToNumber(text) {
    if (!text) return null;
    var m = String(text).replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return isNaN(n) ? null : n;
  }

  function formatSaveDollars(amount) {
    if (amount == null || isNaN(amount)) return '';
    var s = amount.toFixed(2);
    if (s.indexOf('.') !== -1) s = s.replace(/0+$/, '').replace(/\.$/, '');
    return s;
  }

  function subscriptionSaveAmount(tile, host, cart) {
    if (!tile) return '';
    var compareEl = tile.querySelector('[data-upcart-chunk="cart-item-compare-at-price"]');
    var compare = parseMoneyToNumber(compareEl ? compareEl.textContent : '');
    var subPrice = parseMoneyToNumber(parseSubscribePrice(tile, host, cart));
    if (compare != null && subPrice != null && compare > subPrice) {
      return formatSaveDollars(compare - subPrice);
    }
    return '';
  }

  function parseSubCopyParts(tile, host, cart) {
    var saveAmt = subscriptionSaveAmount(tile, host, cart);
    if (!saveAmt) {
      var savingsEl = tile.querySelector('[data-upcart-chunk="cart-item-savings"]');
      if (savingsEl) {
        var m = savingsEl.textContent.match(/[\d.,]+/);
        saveAmt = m ? m[0] : '';
      }
    }
    return {
      line: saveAmt ? 'Save $' + saveAmt + ' on this order' : 'Save on this order',
      gift: tileIsStarterKit(tile) ? '+ Free gifts included' : '',
    };
  }

  function parseSubCopy(tile, host, cart) {
    var parts = parseSubCopyParts(tile, host, cart);
    return parts.gift ? parts.line + ' ' + parts.gift : parts.line;
  }

  function paintSubCopyEl(subEl, tile, host, cart) {
    if (!subEl || !tile) return;
    var parts = parseSubCopyParts(tile, host, cart);
    var line = subEl.querySelector('.nb-sub__sub-line');
    var gift = subEl.querySelector('.nb-sub__sub-gift');
    if (!line || !gift) {
      subEl.innerHTML =
        '<span class="nb-sub__sub-line"></span><span class="nb-sub__sub-gift"></span>';
      line = subEl.querySelector('.nb-sub__sub-line');
      gift = subEl.querySelector('.nb-sub__sub-gift');
    }
    if (line) line.textContent = parts.line;
    if (gift) {
      gift.textContent = parts.gift;
      gift.hidden = !parts.gift;
    }
  }

  function formatShopifyCents(cents) {
    var n = Number(cents);
    if (!n || isNaN(n)) return '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(n);
    }
    return '$' + (n / 100).toFixed(2);
  }

  function parseLineItemDisplayPrice(tile) {
    var el = tile.querySelector('[data-upcart-chunk="cart-item-price"]');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function priceFromSelectOption(opt) {
    if (!opt) return '';
    var attrs = [
      'data-price',
      'data-variant-price',
      'data-subscription-price',
      'data-plan-price',
      'data-amount',
    ];
    var i;
    for (i = 0; i < attrs.length; i++) {
      var raw = opt.getAttribute(attrs[i]);
      if (!raw) continue;
      if (/^\d+$/.test(String(raw).trim())) {
        return formatShopifyCents(Number(raw));
      }
      if (String(raw).indexOf('$') !== -1) return String(raw).trim();
    }
    var text = (opt.textContent || opt.label || '').replace(/\s+/g, ' ').trim();
    var m = text.match(/\$\s*[\d,]+(?:\.\d{1,2})?/);
    return m ? m[0].replace(/\s+/g, '') : '';
  }

  function subscribePriceFromCartItem(it) {
    if (!it) return '';
    if (it.selling_plan_allocation) {
      var spa = it.selling_plan_allocation;
      var cents =
        spa.per_delivery_price != null
          ? spa.per_delivery_price
          : spa.price != null
            ? spa.price
            : null;
      if (cents != null) return formatShopifyCents(cents);
    }
    if (cartItemHasSubscription(it)) {
      if (it.final_price != null) return formatShopifyCents(it.final_price);
      if (it.discounted_price != null) return formatShopifyCents(it.discounted_price);
    }
    return '';
  }

  function subscribePriceFromVariant(variant, planId) {
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) {
      return '';
    }
    var allocs = variant.selling_plan_allocations;
    var pick = null;
    var i;
    for (i = 0; i < allocs.length; i++) {
      if (planId && String(allocs[i].selling_plan_id) === String(planId)) {
        pick = allocs[i];
        break;
      }
    }
    if (!pick) pick = allocs[0];
    var cents = pick.price != null ? pick.price : pick.per_delivery_price;
    return cents != null ? formatShopifyCents(cents) : '';
  }

  function preferredSubscriptionPlanId(host, tile) {
    var sel = findSubscriptionSelect(host, tile);
    if (!sel || !sel.options) return null;
    var idx =
      sel.selectedIndex >= 0 && isSelectOnSubscriptionPlan(sel)
        ? sel.selectedIndex
        : firstSubscriptionOptionIndex(sel);
    if (idx < 0) return null;
    return sellingPlanIdFromSelectOption(sel.options[idx], tile);
  }

  function parseSubscribePrice(tile, host, cart) {
    if (cart) {
      var ctx = cartLineForTile(tile, cart);
      if (ctx) {
        var fromCart = subscribePriceFromCartItem(ctx.item);
        if (fromCart) return fromCart;
      }
    }

    var sel = findSubscriptionSelect(host, tile);
    if (sel && sel.options && sel.options.length) {
      var idx =
        sel.selectedIndex >= 0 && isSelectOnSubscriptionPlan(sel)
          ? sel.selectedIndex
          : firstSubscriptionOptionIndex(sel);
      if (idx >= 0) {
        var fromOpt = priceFromSelectOption(sel.options[idx]);
        if (fromOpt) return fromOpt;
      }
    }

    if (host) {
      var hostPrice =
        host.querySelector('[data-upcart-chunk="subscription-price"]') ||
        host.querySelector('[data-upcart-chunk="cart-item-subscription-price"]') ||
        host.querySelector('.upcart-public-component-product-tile__subscription-price') ||
        host.querySelector('.upcart-internal-component-product-tile__subscription-price');
      if (hostPrice && hostPrice.textContent.trim()) return hostPrice.textContent.trim();
    }

    var vid = variantIdFromTile(tile);
    var planId = preferredSubscriptionPlanId(host, tile);
    if (vid) {
      var cacheKey = vid + ':' + (planId || 'default');
      if (nbVariantSubPriceCache[cacheKey]) return nbVariantSubPriceCache[cacheKey];
    }

    return '';
  }

  function refreshSubscribePriceAsync(host, tile, cart) {
    if (!host || !tile || !host.isConnected) return;
    var vid = variantIdFromTile(tile);
    if (!vid) return;

    var overlay = findSubOverlay(host);
    var priceEl = overlay && overlay.querySelector('.nb-sub__price');
    if (!priceEl) return;

    var syncPrice = parseSubscribePrice(tile, host, cart);
    if (syncPrice) priceEl.textContent = syncPrice;
    var subEl = overlay.querySelector('.nb-sub__sub');
    if (subEl) paintSubCopyEl(subEl, tile, host, cart);

    var planId = preferredSubscriptionPlanId(host, tile);
    var cacheKey = vid + ':' + (planId || 'default');
    if (nbVariantSubPriceCache[cacheKey]) {
      priceEl.textContent = nbVariantSubPriceCache[cacheKey];
      if (subEl) paintSubCopyEl(subEl, tile, host, cart);
      return;
    }

    fetch(shopifyCartRoot() + '/variants/' + vid + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (variant) {
        if (!variant || !host.isConnected) return;
        var formatted = subscribePriceFromVariant(variant, planId);
        if (!formatted) return;
        nbVariantSubPriceCache[cacheKey] = formatted;
        var liveOverlay = findSubOverlay(host);
        var livePrice = liveOverlay && liveOverlay.querySelector('.nb-sub__price');
        if (livePrice) livePrice.textContent = formatted;
        var liveSub = liveOverlay && liveOverlay.querySelector('.nb-sub__sub');
        if (liveSub) paintSubCopyEl(liveSub, tile, host, cart);
      })
      .catch(function () {});
  }

  function upgradeBtn(host) {
    return (
      host.querySelector('.upcart-public-component-product-tile__subscription-upgrade-btn') ||
      host.querySelector('.upcart-internal-component-product-tile__subscription-upgrade-btn')
    );
  }

  /** Subscription plan <select> inside upgrade host (subscribed) or elsewhere on tile. */
  function findSubscriptionSelect(host, tile) {
    if (host) {
      var inHost =
        host.querySelector('.upcart-public-component-product-tile__select') ||
        host.querySelector('.upcart-internal-component-product-tile__select');
      if (inHost && inHost.options && inHost.options.length) {
        return inHost;
      }
    }
    if (!tile) return null;
    var sels = tile.querySelectorAll('select');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      if (!sel.options || !sel.options.length) continue;
      for (var j = 0; j < sel.options.length; j++) {
        var t = (sel.options[j].textContent || sel.options[j].label || '').toLowerCase();
        if (
          t.indexOf('day') !== -1 ||
          t.indexOf('every ') !== -1 ||
          t.indexOf('flexible plan') !== -1 ||
          t.indexOf('deliver') !== -1
        ) {
          return sel;
        }
      }
    }
    return null;
  }

  function isSubscribedSelectOnly(host) {
    return !upgradeBtn(host) && !!findSubscriptionSelect(host, tileFromHost(host));
  }

  function variantIdFromTile(tile) {
    if (!tile) return null;
    var attrs = [
      'data-variant-id',
      'data-item-variant-id',
      'data-cart-item-variant-id',
      'data-line-item-variant-id',
    ];
    for (var a = 0; a < attrs.length; a++) {
      var el = tile.querySelector('[' + attrs[a] + ']');
      if (!el) continue;
      var v = el.getAttribute(attrs[a]);
      if (v && /^\d+$/.test(String(v).trim())) return String(v).trim();
    }
    var inp = tile.querySelector('input[name="id"], form input[name="id"]');
    if (inp && inp.value && /^\d+$/.test(String(inp.value).trim())) return String(inp.value).trim();
    var links = tile.querySelectorAll('a[href*="variant="]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].href.match(/[?&]variant=(\d+)/);
      if (m) return m[1];
    }
    return null;
  }

  /** 1-based cart line index when UpCart embeds it on a parent (optional). */
  function lineIndexHintFromTile(tile) {
    if (!tile) return null;
    var el = tile;
    for (var s = 0; s < 16 && el; s++) {
      if (el.getAttribute) {
        var d =
          el.getAttribute('data-line') ||
          el.getAttribute('data-cart-line') ||
          el.getAttribute('data-line-item-index');
        if (d && /^\d+$/.test(String(d).trim())) return Number(String(d).trim());
      }
      el = el.parentElement;
    }
    return null;
  }

  /** Shopify cart line_item.key when exposed on the row (reliable for /cart/change.js). */
  function lineKeyFromTile(tile) {
    if (!tile) return null;
    var keyAttrs = [
      'data-line-item-key',
      'data-cart-item-key',
      'data-key',
      'data-item-key',
      'data-cart-line-key',
    ];
    var li =
      tile.closest('.upcart-public-cart-item') ||
      tile.closest('.upcart-internal-cart-item') ||
      tile;
    var a;
    for (a = 0; a < keyAttrs.length; a++) {
      if (li.getAttribute && li.getAttribute(keyAttrs[a])) {
        var onLi = String(li.getAttribute(keyAttrs[a])).trim();
        if (onLi.length > 2) return onLi;
      }
      var nodes = li.querySelectorAll('[' + keyAttrs[a] + ']');
      for (var n = 0; n < nodes.length; n++) {
        var val = nodes[n].getAttribute(keyAttrs[a]);
        if (val && String(val).trim().length > 2) return String(val).trim();
      }
    }
    var el = tile;
    for (var s = 0; s < 16 && el; s++) {
      if (el.getAttribute) {
        for (a = 0; a < keyAttrs.length; a++) {
          var k = el.getAttribute(keyAttrs[a]);
          if (k && String(k).trim().length > 2) return String(k).trim();
        }
      }
      el = el.parentElement;
    }
    return null;
  }

  /** 1-based line index from UpCart cart item row order. */
  function lineIndexFromDom(tile) {
    if (!tile) return null;
    var li =
      tile.closest('.upcart-public-cart-item') || tile.closest('.upcart-internal-cart-item');
    if (!li || !li.parentElement) return null;
    var items = li.parentElement.querySelectorAll(
      '.upcart-public-cart-item,.upcart-internal-cart-item'
    );
    for (var i = 0; i < items.length; i++) {
      if (items[i] === li) return i + 1;
    }
    return null;
  }

  function cartItemsListEl() {
    var root = cartRoot();
    if (!root) return null;
    return (
      root.querySelector('.upcart-internal-cart-items.upcart-public-cart-items') ||
      root.querySelector('.upcart-internal-cart-items') ||
      root.querySelector('.upcart-public-cart-items')
    );
  }

  function cartLineElements(listEl) {
    if (!listEl) return [];
    return listEl.querySelectorAll('.upcart-public-cart-item,.upcart-internal-cart-item');
  }

  function productTitleFromCartLine(li) {
    if (!li) return '';
    var link =
      li.querySelector('.upcart-public-component-product-tile__title-link') ||
      li.querySelector('.upcart-internal-component-product-tile__title-link') ||
      li.querySelector('[class*="product-title"]');
    return link ? link.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  function normalizeCartItemTitle(it) {
    return String(it && (it.product_title || it.title) ? it.product_title || it.title : '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function tileLooksSubscribedInDom(tile) {
    if (!tile) return false;
    if (
      tile.querySelector('.upcart-public-product-properties__subscription') ||
      tile.querySelector('.upcart-internal-product-properties__subscription')
    ) {
      return true;
    }
    if (sellingPlanIdFromTile(tile)) return true;
    var host = hostFromTile(tile);
    if (host) {
      if (isSubscribedSelectOnly(host)) return true;
      var sel = findSubscriptionSelect(host, tile);
      if (sel && isSelectOnSubscriptionPlan(sel)) return true;
    }
    return false;
  }

  function wantSubscriptionForTile(tile) {
    var ui = readLineUi(tile);
    if (ui) {
      if (ui.unsubbed || ui.deactivating) return false;
      if (ui.activating || (ui.selected && ui.expanded)) return true;
    }
    return tileLooksSubscribedInDom(tile);
  }

  function tileHasSubscriptionProperty(tile) {
    if (!tile) return false;
    return !!(
      tile.querySelector('.upcart-public-product-properties__subscription') ||
      tile.querySelector('.upcart-internal-product-properties__subscription')
    );
  }

  function pickBestCartMatchForTile(tile, matches) {
    if (!matches || !matches.length) return null;
    if (matches.length === 1) return matches[0];

    var domLine = lineIndexFromDom(tile);
    if (domLine != null) {
      for (var d = 0; d < matches.length; d++) {
        if (matches[d].line === domLine) return matches[d];
      }
    }

    var wantPlan = sellingPlanIdFromTile(tile);
    if (wantPlan) {
      for (var p = 0; p < matches.length; p++) {
        var itemPlan = getSellingPlanIdFromCartItem(matches[p].item);
        if (itemPlan && String(itemPlan) === String(wantPlan)) return matches[p];
      }
    }

    var wantSub = wantSubscriptionForTile(tile);
    var subHits = [];
    for (var s = 0; s < matches.length; s++) {
      if (cartItemHasSubscription(matches[s].item) === wantSub) subHits.push(matches[s]);
    }
    if (subHits.length === 1) return subHits[0];

    if (subHits.length) return subHits[0];
    return matches[0];
  }

  function findCartLineForItem(cartItem, listEl, used) {
    if (!cartItem || !listEl) return null;
    var lines = cartLineElements(listEl);
    var vid = String(cartItem.variant_id || '');
    var key = cartItem.key ? String(cartItem.key) : '';
    var wantTitle = normalizeCartItemTitle(cartItem);
    var wantSub = cartItemHasSubscription(cartItem);
    var i;

    if (key) {
      for (i = 0; i < lines.length; i++) {
        if (used.has(lines[i])) continue;
        var domKey = lineKeyFromTile(lines[i]);
        if (domKey && domKey === key) {
          used.add(lines[i]);
          return lines[i];
        }
      }
    }

    if (vid) {
      var variantHits = [];
      for (i = 0; i < lines.length; i++) {
        if (used.has(lines[i])) continue;
        if (variantIdFromTile(lines[i]) === vid) variantHits.push(lines[i]);
      }
      if (variantHits.length === 1) {
        used.add(variantHits[0]);
        return variantHits[0];
      }
      if (variantHits.length > 1) {
        var wantPlan = getSellingPlanIdFromCartItem(cartItem);
        if (wantPlan) {
          for (i = 0; i < variantHits.length; i++) {
            if (used.has(variantHits[i])) continue;
            var domPlan = sellingPlanIdFromTile(variantHits[i]);
            if (domPlan && String(domPlan) === String(wantPlan)) {
              used.add(variantHits[i]);
              return variantHits[i];
            }
          }
        }
        for (i = 0; i < variantHits.length; i++) {
          if (used.has(variantHits[i])) continue;
          var hasSubProp = tileHasSubscriptionProperty(variantHits[i]);
          if (wantSub && hasSubProp) {
            used.add(variantHits[i]);
            return variantHits[i];
          }
          if (!wantSub && !hasSubProp) {
            used.add(variantHits[i]);
            return variantHits[i];
          }
        }
        for (i = 0; i < variantHits.length; i++) {
          if (!used.has(variantHits[i])) {
            used.add(variantHits[i]);
            return variantHits[i];
          }
        }
      }
    }

    if (wantTitle) {
      for (i = 0; i < lines.length; i++) {
        if (used.has(lines[i])) continue;
        var domTitle = productTitleFromCartLine(lines[i]);
        if (!domTitle) continue;
        if (
          domTitle === wantTitle ||
          domTitle.indexOf(wantTitle) === 0 ||
          wantTitle.indexOf(domTitle) === 0
        ) {
          used.add(lines[i]);
          return lines[i];
        }
      }
    }
    return null;
  }

  /* NB-005-All-CartDrawer-CVR-AB — UpCart may re-render lines out of cart.js order after subscribe */
  function syncCartItemsOrder(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    var listEl = cartItemsListEl();
    if (!listEl) return false;

    var used = new Set();
    var ordered = [];
    var i;
    for (i = 0; i < cart.items.length; i++) {
      var li = findCartLineForItem(cart.items[i], listEl, used);
      if (li) ordered.push(li);
    }

    var lines = cartLineElements(listEl);
    for (i = 0; i < lines.length; i++) {
      if (!used.has(lines[i])) ordered.push(lines[i]);
    }
    if (ordered.length !== lines.length) return false;

    var needsMove = false;
    for (i = 0; i < ordered.length; i++) {
      if (listEl.children[i] !== ordered[i]) {
        needsMove = true;
        break;
      }
    }
    if (!needsMove) return false;

    for (i = 0; i < ordered.length; i++) {
      listEl.appendChild(ordered[i]);
    }
    return true;
  }

  function cartItemHasSubscription(it) {
    if (!it) return false;
    if (it.selling_plan_allocation) return true;
    if (it.selling_plan_id) return true;
    var sp = it.selling_plan;
    if (sp != null && sp !== '' && sp !== false) return true;
    return false;
  }

  function getSellingPlanIdFromCartItem(it) {
    if (!it) return null;
    if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
      return it.selling_plan_allocation.selling_plan.id;
    }
    if (it.selling_plan_id) return it.selling_plan_id;
    return null;
  }

  function sellingPlanIdFromTile(tile) {
    if (!tile) return null;
    var host = hostFromTile(tile);
    if (host) {
      var sel = findSubscriptionSelect(host, tile);
      if (sel && sel.options && sel.selectedIndex >= 0) {
        var fromSel = sellingPlanIdFromSelectOption(sel.options[sel.selectedIndex], tile);
        if (fromSel) return String(fromSel);
      }
    }
    var links = tile.querySelectorAll('a[href*="selling_plan="]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].href.match(/[?&]selling_plan=(\d+)/);
      if (m) return m[1];
    }
    return null;
  }

  function subscriptionLineResult(cart, index) {
    var it = cart.items[index];
    if (!it || !cartItemHasSubscription(it)) return null;
    return { line: index + 1, quantity: it.quantity, key: it.key };
  }

  function findSubscriptionLineInCart(tile, cart) {
    var ctx = cartLineForTile(tile, cart);
    if (!ctx || !cartItemHasSubscription(ctx.item)) return null;
    return { line: ctx.line, quantity: ctx.item.quantity, key: ctx.item.key };
  }

  function shopifyCartRoot() {
    return typeof Shopify !== 'undefined' && Shopify.routes && typeof Shopify.routes.root === 'string'
      ? Shopify.routes.root.replace(/\/$/, '')
      : '';
  }

  function fetchShopifyCart() {
    return fetch(shopifyCartRoot() + '/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) return Promise.reject(new Error('nb-cart-load'));
      return r.json();
    });
  }

  function invalidateCartCache() {
    nbCartCache = null;
    nbCartCacheAt = 0;
  }

  function getCartCached(maxAgeMs) {
    var maxAge = maxAgeMs == null ? 400 : maxAgeMs;
    if (nbCartCache && Date.now() - nbCartCacheAt < maxAge) {
      return Promise.resolve(nbCartCache);
    }
    return fetchShopifyCart().then(function (cart) {
      nbCartCache = cart;
      nbCartCacheAt = Date.now();
      return cart;
    });
  }

  function isSelectOnSubscriptionPlan(sel) {
    if (!sel || !sel.options || sel.selectedIndex < 0) return false;
    return !isOneTimePurchaseOption(sel.options[sel.selectedIndex]);
  }

  function shouldPreserveSubscribeUi(host, tile, cart) {
    if (!host || !tile) return false;
    if (host.dataset.nbExpandBusy === '1' || host.dataset.nbSubBusy === '1') return true;
    if (host.dataset.nbActivating === '1') return true;
    var ui = readLineUi(tile);
    if (ui && ui.unsubbed) return false;
    if (ui && (ui.activating || ui.deactivating || ui.pending || ui.freqChanging)) return true;
    if (
      host.hasAttribute('data-nb-expanded') &&
      cart &&
      cartStillHasSubscriptionForTile(tile, cart)
    ) {
      return true;
    }
    return false;
  }

  function shouldShowSubscribeSelected(host, tile, cart) {
    if (!host || !tile) return false;
    var ui = readLineUi(tile);
    if (ui && ui.unsubbed) return false;
    if (host.dataset.nbExpandBusy === '1' || host.dataset.nbSubBusy === '1') return true;
    if (host.dataset.nbActivating === '1') return true;
    if (cart && cartStillHasSubscriptionForTile(tile, cart)) return true;
    if (ui && ui.deactivating) return true;
    if (ui && ui.activating) return true;
    if (
      ui &&
      ui.selected &&
      ui.expanded &&
      cart &&
      cartStillHasSubscriptionForTile(tile, cart)
    ) {
      return true;
    }
    return false;
  }

  function reconcileLineUiFromCart(tile, cart) {
    if (!tile || !cart) return;
    var ui = readLineUi(tile);
    if (ui && (ui.activating || ui.deactivating || ui.freqChanging)) return;
    if (ui && ui.unsubbed) return;

    var cartSub = cartStillHasSubscriptionForTile(tile, cart);

    if (ui && ui.pending && !ui.activating && !ui.deactivating) {
      patchLineUi(tile, {
        pending: false,
        selected: !!cartSub,
        expanded: !!cartSub,
        activating: false,
      });
      return;
    }
    if (cartSub) {
      patchLineUi(tile, { selected: true, expanded: true, pending: false, activating: false });
      return;
    }
    patchLineUi(tile, {
      selected: false,
      expanded: false,
      pending: false,
      activating: false,
      unsubbed: false,
    });
  }

  function waitForSubscriptionInCart(tile, attemptsLeft, delayMs) {
    return getCartCached(0).then(function (cart) {
      if (cartStillHasSubscriptionForTile(tile, cart)) {
        nbCartCache = cart;
        nbCartCacheAt = Date.now();
        return true;
      }
      if (attemptsLeft <= 0) return false;
      return new Promise(function (resolve) {
        setTimeout(function () {
          invalidateCartCache();
          waitForSubscriptionInCart(tile, attemptsLeft - 1, delayMs).then(resolve);
        }, delayMs);
      });
    });
  }

  function syncOverlayExpandedState(host, overlay) {
    if (!host || !overlay) return;
    var expanded =
      host.hasAttribute('data-nb-expanded') ||
      host.classList.contains('nb-sub--selected') ||
      host.dataset.nbActivating === '1';
    overlay.classList.toggle('nb-sub-overlay--expanded', expanded);
  }

  function postCartChange(payload) {
    return fetch(shopifyCartRoot() + '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) return Promise.reject(body);
        return body;
      });
    });
  }

  function dispatchCartUpdatedEvents() {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('upcart:cartUpdated', { bubbles: true }));
    } catch (e2) {}
  }

  function triggerUpcartCartRefresh() {
    if (nbRefreshTimer) clearTimeout(nbRefreshTimer);
    nbRefreshTimer = setTimeout(function () {
      nbRefreshTimer = null;
      try {
        if (typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        }
      } catch (e3) {}
    }, 200);
  }

  /** Shopify `/cart/change.js` — prefer line item key when available. */
  function buildSellingPlanRemovalPayload(found) {
    return {
      line: found.line,
      quantity: found.quantity,
      selling_plan: null,
    };
  }

  function removeSellingPlanViaChange(found) {
    var payloads = [];
    if (found.key) {
      payloads.push({ id: found.key, quantity: found.quantity, selling_plan: null });
      payloads.push({ id: found.key, quantity: found.quantity, selling_plan: '' });
    }
    payloads.push(buildSellingPlanRemovalPayload(found));
    payloads.push({ line: found.line, quantity: found.quantity, selling_plan: '' });

    function tryPayload(index) {
      if (index >= payloads.length) {
        return Promise.reject(new Error('nb-plan-remove-failed'));
      }
      return postCartChange(payloads[index]).catch(function () {
        return tryPayload(index + 1);
      });
    }

    return tryPayload(0);
  }

  function waitForOneTimeInCart(tile, attemptsLeft, delayMs) {
    return getCartCached(0).then(function (cart) {
      if (!cartStillHasSubscriptionForTile(tile, cart)) {
        nbCartCache = cart;
        nbCartCacheAt = Date.now();
        return true;
      }
      if (attemptsLeft <= 0) return false;
      return new Promise(function (resolve) {
        setTimeout(function () {
          invalidateCartCache();
          waitForOneTimeInCart(tile, attemptsLeft - 1, delayMs).then(resolve);
        }, delayMs);
      });
    });
  }

  function removeSellingPlanForTile(tile, opts) {
    opts = opts || {};
    return withCartMutation(function () {
      return fetchShopifyCart()
        .then(function (cart) {
          var found = findSubscriptionLineInCart(tile, cart);
          if (!found) return Promise.reject(new Error('nb-no-sub-line'));
          return { found: found };
        })
        .then(function (ctx) {
          return waitForOneTimeInCart(tile, 2, 100).then(function (alreadyOneTime) {
            if (alreadyOneTime) return getCartCached(0);
            return removeSellingPlanViaChange(ctx.found)
              .then(function () {
                return fetchShopifyCart();
              })
              .then(function (freshCart) {
                if (!cartStillHasSubscriptionForTile(tile, freshCart)) {
                  return freshCart;
                }
                return waitForOneTimeInCart(tile, 5, 200).then(function (ok) {
                  if (ok) return getCartCached(0);
                  return Promise.reject(new Error('nb-still-subscribed'));
                });
              });
          });
        })
        .then(function (freshCart) {
          nbCartCache = freshCart;
          nbCartCacheAt = Date.now();
          dispatchCartUpdatedEvents();
          if (!opts.skipRefresh) triggerUpcartCartRefresh();
          return freshCart;
        });
    });
  }

  /** UpCart adds a one-time row (e.g. value="otp" under "Full price"); we hide it from pills — use the subscribe card to switch back. */
  function isOneTimePurchaseOption(opt) {
    if (!opt) return true;
    var val = String(opt.value || '').trim().toLowerCase();
    if (val === 'otp' || val === 'one_time' || val === 'onetime') return true;
    var t = (opt.textContent || opt.label || '').trim().toLowerCase();
    if (t.indexOf('one-time') !== -1 && t.indexOf('purchase') !== -1) return true;
    if (t === 'one time purchase' || t.replace(/\s+/g, ' ') === 'one-time purchase') return true;
    var pg = opt.parentElement;
    if (pg && pg.tagName === 'OPTGROUP') {
      var lbl = String(pg.label || '').toLowerCase();
      if (lbl.indexOf('full price') !== -1) return true;
    }
    return false;
  }

  function countSubscriptionPillOptions(sel) {
    if (!sel || !sel.options) return 0;
    var n = 0;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.disabled) continue;
      if (isOneTimePurchaseOption(o)) continue;
      n++;
    }
    return n;
  }

  /** UpCart listens on the plan <select>; also reinforce with /cart/change.js when possible. */
  function oneTimeOptionIndex(sel) {
    if (!sel || !sel.options) return -1;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].disabled) continue;
      if (isOneTimePurchaseOption(sel.options[i])) return i;
    }
    return -1;
  }

  function firstSubscriptionOptionIndex(sel) {
    if (!sel || !sel.options) return -1;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].disabled) continue;
      if (!isOneTimePurchaseOption(sel.options[i])) return i;
    }
    return -1;
  }

  function sellingPlanIdFromSelectOption(opt, tile) {
    if (!opt) return null;
    var val = String(opt.value || '').trim();
    if (!val) return null;
    var gid = val.match(/SellingPlan\/(\d+)/i);
    if (gid) return gid[1];
    var dataPlan =
      opt.getAttribute('data-selling-plan-id') ||
      opt.getAttribute('data-selling-plan') ||
      opt.getAttribute('data-selling_plan');
    if (dataPlan && /^\d+$/.test(String(dataPlan).trim())) return String(dataPlan).trim();
    if (/^\d+$/.test(val)) {
      var vid = tile ? variantIdFromTile(tile) : null;
      if (vid && val === String(vid)) return null;
      return val;
    }
    return null;
  }

  function changeSellingPlanForTile(tile, sellingPlanId) {
    var planNum = Number(sellingPlanId);
    if (!planNum || planNum <= 0) return Promise.reject(new Error('nb-invalid-plan-id'));
    return withCartMutation(function () {
      return fetchShopifyCart()
        .then(function (cart) {
          var ctx = cartLineForTile(tile, cart);
          if (!ctx || !cartItemHasSubscription(ctx.item)) {
            return Promise.reject(new Error('nb-no-sub-line'));
          }
          var found = { line: ctx.line, quantity: ctx.item.quantity, key: ctx.item.key };
          var payloads = [];
          if (found.key) {
            payloads.push({ id: found.key, quantity: found.quantity, selling_plan: planNum });
          }
          payloads.push({ line: found.line, quantity: found.quantity, selling_plan: planNum });

          function tryPayload(index) {
            if (index >= payloads.length) {
              return Promise.reject(new Error('nb-plan-change-failed'));
            }
            return postCartChange(payloads[index]).catch(function () {
              return tryPayload(index + 1);
            });
          }
          return tryPayload(0);
        })
        .then(function (cart) {
          nbCartCache = cart;
          nbCartCacheAt = Date.now();
          dispatchCartUpdatedEvents();
          return cart;
        });
    });
  }

  function applyFrequencySelectChange(host, sel, idx) {
    if (!sel || idx < 0) return false;
    var optEl = sel.options[idx];
    if (!optEl || isOneTimePurchaseOption(optEl)) return false;
    var wantValue = String(optEl.value);
    var prevValue = String(sel.value);
    var prevIndex = sel.selectedIndex;

    if (host) host.dataset.nbProgrammaticNative = '1';
    try {
      try {
        var setter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value');
        if (setter && setter.set) setter.set.call(sel, wantValue);
        else sel.selectedIndex = idx;
      } catch (eSet) {
        sel.selectedIndex = idx;
      }
      var valueChanged = String(sel.value) !== prevValue;
      var indexChanged = sel.selectedIndex !== prevIndex;
      if (!valueChanged && !indexChanged) return false;
      sel.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
      return true;
    } finally {
      if (host && host.dataset.nbProgrammaticNative) delete host.dataset.nbProgrammaticNative;
    }
  }

  function scheduleFreqCartFallback(markerId, token, liveHost, tile, sel, idx) {
    setTimeout(function () {
      if (nbFreqBusy[markerId] !== token) return;
      if (sel && sel.isConnected && sel.selectedIndex === idx) {
        completeFrequencyChange(markerId, token, liveHost, tile, 'select-async');
        return;
      }
      invalidateCartCache();
      getCartCached(0)
        .then(function (cart) {
          if (nbFreqBusy[markerId] !== token) return;
          if (!cartStillHasSubscriptionForTile(tile, cart)) {
            nbFreqLog('pill fallback abort not subscribed', { markerId: markerId });
            completeFrequencyChange(markerId, token, liveHost, tile, 'not-subscribed');
            return;
          }
          var optEl = sel && sel.options && sel.options[idx];
          var planId = sellingPlanIdFromSelectOption(optEl, tile);
          nbFreqLog('pill select stuck, try cart API', {
            idx: idx,
            selectedAfter: sel ? sel.selectedIndex : null,
            planId: planId,
          });
          if (!planId) {
            completeFrequencyChange(markerId, token, liveHost, tile, 'no-plan-id');
            return;
          }
          return changeSellingPlanForTile(tile, planId).catch(function (err) {
            nbFreqLog('pill cart API failed', err);
            completeFrequencyChange(markerId, token, liveHost, tile, 'api-fail');
          });
        })
        .catch(function () {
          if (nbFreqBusy[markerId] === token) {
            completeFrequencyChange(markerId, token, liveHost, tile, 'cart-read-fail');
          }
        });
    }, 400);
  }

  function applySelectOption(sel, idx) {
    if (!sel || idx < 0) return;
    var optEl = sel.options[idx];
    if (!optEl) return;
    sel.selectedIndex = idx;
    try {
      var proto = window.HTMLSelectElement && window.HTMLSelectElement.prototype;
      var desc = proto && Object.getOwnPropertyDescriptor(proto, 'value');
      if (desc && desc.set) desc.set.call(sel, String(optEl.value));
    } catch (e0) {}
    try {
      if (sel.focus) sel.focus();
    } catch (eF) {}
    try {
      sel.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
      sel.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    } catch (e1) {}
  }

  function applySelectOneTime(sel, otpIdx) {
    applySelectOption(sel, otpIdx);
  }

  function switchLineToOneTimePurchase(tile, host) {
    if (shouldBlockUnsubscribe(host, tile, nbCartCache)) {
      return Promise.resolve({ ok: false, reason: 'nb-sub-locked' });
    }
    var sel = findSubscriptionSelect(host, tile);
    var otpIdx = oneTimeOptionIndex(sel);
    if (otpIdx >= 0 && sel) {
      invalidateCartCache();
      applySelectOneTime(sel, otpIdx);
      return waitForOneTimeInCart(tile, 30, 50)
        .then(function (ok) {
          if (ok) return { ok: true, viaSelect: true };
          return removeSellingPlanForTile(tile, { skipRefresh: true }).then(function (b) {
            return { ok: true, cart: b, viaApi: true };
          });
        })
        .catch(function (err) {
          if (err && err.message === 'nb-cart-load') {
            return { ok: false, err: err };
          }
          if (
            err &&
            (err.message === 'nb-no-sub-line' || err.message === 'nb-still-subscribed')
          ) {
            return { ok: false, err: err, reason: err.message };
          }
          return { ok: false, err: err };
        })
        .then(function (result) {
          if (result && result.ok !== false) {
            invalidateCartCache();
            dispatchCartUpdatedEvents();
            burstResync();
            if (result.viaApi) triggerUpcartCartRefresh();
          }
          return result;
        });
    }
    return removeSellingPlanForTile(tile, { skipRefresh: true })
      .then(function (b) {
        return { ok: true, cart: b, viaApi: true };
      })
      .catch(function (err) {
        if (err && err.message === 'nb-cart-load') {
          return { ok: false, err: err };
        }
        if (
          err &&
          (err.message === 'nb-no-sub-line' || err.message === 'nb-still-subscribed')
        ) {
          return { ok: false, err: err, reason: err.message };
        }
        return { ok: false, err: err };
      })
      .then(function (result) {
        if (result && result.ok !== false) {
          invalidateCartCache();
          dispatchCartUpdatedEvents();
          burstResync();
          if (result.viaApi) triggerUpcartCartRefresh();
        }
        return result;
      });
  }

  function resetSubscribeUiState(host, tile, btn, keepOverlay) {
    host.removeAttribute('data-nb-expanded');
    host.classList.remove('nb-sub--selected');
    if (keepOverlay && tile) {
      ensureUncheckedSubscribeCard(host, tile);
    } else {
      removeStaleStaticCard(host);
    }
    removeFreqUI(host);
    if (tile) stripNativeSelectMarks(tile);
    if (btn) btn.setAttribute('aria-pressed', 'false');
  }

  function markUnsubPending(host) {
    if (host) host.dataset.nbUnsubPending = '1';
  }

  function clearUnsubPending(host) {
    if (!host) return;
    if (host.dataset.nbUnsubPending) delete host.dataset.nbUnsubPending;
    if (host.dataset.nbUnsubChecking) delete host.dataset.nbUnsubChecking;
  }

  function markUnsubDone(host) {
    if (host) host.dataset.nbUnsubDone = '1';
  }

  function clearUnsubDone(host) {
    if (host && host.dataset.nbUnsubDone) delete host.dataset.nbUnsubDone;
  }

  function showUncheckedSubscribeUi(host, tile) {
    ensureUncheckedSubscribeCard(host, tile);
    removeFreqUI(host);
    var sel = findSubscriptionSelect(host, tile);
    if (sel) sel.classList.add('nb-sub-native-select');
    ensureSubscribeToggle(host);
  }

  function cartLineForTile(tile, cart) {
    if (!tile || !cart || !cart.items || !cart.items.length) return null;

    var key = lineKeyFromTile(tile);
    if (key) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].key) === key) {
          return { item: cart.items[i], line: i + 1 };
        }
      }
    }

    var vid = variantIdFromTile(tile);
    if (vid) {
      var matches = [];
      for (var j = 0; j < cart.items.length; j++) {
        if (String(cart.items[j].variant_id) === vid) {
          matches.push({ item: cart.items[j], line: j + 1 });
        }
      }
      if (matches.length === 1) return matches[0];
      if (matches.length > 1) {
        return pickBestCartMatchForTile(tile, matches);
      }
    }

    var domLine = lineIndexFromDom(tile);
    if (domLine != null && domLine >= 1 && domLine <= cart.items.length) {
      return { item: cart.items[domLine - 1], line: domLine };
    }
    return null;
  }

  function cartStillHasSubscriptionForTile(tile, cart) {
    var ctx = cartLineForTile(tile, cart);
    if (!ctx) return false;
    return cartItemHasSubscription(ctx.item);
  }

  function tileHasLockedSubscription(tile, cart) {
    if (!tile || !cart) return false;
    if (!cartStillHasSubscriptionForTile(tile, cart)) return false;
    return isLockedSubscriptionHandle(productHandleFromCartTile(tile, cart));
  }

  function shouldBlockUnsubscribe(host, tile, cart) {
    if (!tile) return false;
    var handle = productHandleFromCartTile(tile, cart || nbCartCache);
    if (!isLockedSubscriptionHandle(handle)) return false;
    var liveCart = cart || nbCartCache;
    if (liveCart && cartStillHasSubscriptionForTile(tile, liveCart)) return true;
    return host ? isSubscribeUiActive(host) : false;
  }

  function syncLockedSubscriptionUi(host, tile, cart) {
    if (!host || !tile) return;
    var locked = cart ? tileHasLockedSubscription(tile, cart) : false;
    host.classList.toggle('nb-sub--locked', locked);
    var overlay = findSubOverlay(host);
    if (overlay) overlay.classList.toggle('nb-sub-overlay--locked', locked);
    var btn = upgradeBtn(host);
    if (!btn) return;
    if (locked) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('tabindex');
    }
  }

  function verifyUnsubStateAgainstCart(host, tile) {
    if (!host) return;
    if (host.dataset.nbSubBusy === '1') return;
    if (host.dataset.nbUnsubChecking === '1') return;
    if (host.dataset.nbUnsubPending !== '1') return;
    host.dataset.nbUnsubChecking = '1';
    fetchShopifyCart()
      .then(function (cart) {
        delete host.dataset.nbUnsubChecking;
        if (cartStillHasSubscriptionForTile(tile, cart)) {
          scheduleScan();
          return;
        }
        markUnsubDone(host);
        clearUnsubPending(host);
        patchLineUi(tile, {
          selected: false,
          pending: false,
          expanded: false,
          deactivating: false,
          unsubbed: true,
        });
        invalidateCartCache();
        scheduleScan();
      })
      .catch(function () {
        delete host.dataset.nbUnsubChecking;
      });
  }

  function pillLabelFromOption(opt) {
    var raw = (opt.textContent || opt.label || '').trim();
    var m = raw.match(/(\d+)\s*day/i);
    if (m) return m[1] + ' days';
    if (raw.length > 28) return raw.slice(0, 26) + '…';
    return raw || 'Plan';
  }

  function hostMarker(host, tile, cart) {
    if (host.dataset.nbHostId) return host.dataset.nbHostId;
    tile = tile || tileFromHost(host);
    var stable = expectedMarkerStable(tile, cart);
    host.dataset.nbHostId = stable
      ? 'nb-sub-' + String(stable).replace(/[^a-zA-Z0-9_-]/g, '')
      : 'nb-sub-' + String(Math.random()).slice(2, 10);
    return host.dataset.nbHostId;
  }

  function expectedMarkerStable(tile, cart) {
    if (!tile) return '';
    var v = variantIdFromTile(tile);
    var k = lineKeyFromTile(tile);
    var li = lineIndexFromDom(tile);
    var plan = '';
    if (cart) {
      var ctx = cartLineForTile(tile, cart);
      if (ctx && cartItemHasSubscription(ctx.item)) {
        var cp = getSellingPlanIdFromCartItem(ctx.item);
        if (cp) plan = 'p' + String(cp);
      }
    } else if (tileLooksSubscribedInDom(tile)) {
      var dp = sellingPlanIdFromTile(tile);
      if (dp) plan = 'p' + dp;
    }
    if (k) return 'k' + String(k).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 32);
    if (li) return 'l' + li + (v ? 'v' + v : '') + plan;
    if (v) {
      return 'v' + v + (plan || (tileLooksSubscribedInDom(tile) ? 'sub' : 'otp'));
    }
    return '';
  }

  function expectedMarkerId(tile, cart) {
    var stable = expectedMarkerStable(tile, cart);
    return stable ? 'nb-sub-' + String(stable).replace(/[^a-zA-Z0-9_-]/g, '') : null;
  }

  function purgeMarkerArtifacts(markerId, keepHost) {
    if (!markerId) return;
    var root = cartRoot() || document;
    var overlays = root.querySelectorAll('.nb-sub-overlay[data-nb-host-id="' + markerId + '"]');
    for (var o = 0; o < overlays.length; o++) {
      var overlay = overlays[o];
      if (keepHost && overlay.previousElementSibling === keepHost) continue;
      safeRemoveNode(overlay);
    }
    delete nbFreqBusy[markerId];
    cancelFreqSession(markerId);
  }

  function rebindHostMarkerIfStale(host, tile, cart) {
    if (!host || !tile) return hostMarker(host, tile, cart);
    var expected = expectedMarkerId(tile, cart);
    if (!expected) return hostMarker(host, tile, cart);
    var current = host.dataset.nbHostId;
    if (current === expected) return expected;
    if (current) purgeMarkerArtifacts(current, host);
    delete host.dataset.nbHostId;
    host.dataset.nbHostId = expected;
    var overlay = findSubOverlay(host);
    if (overlay) overlay.setAttribute('data-nb-host-id', expected);
    var wrap = findFreqWrap(host);
    if (wrap) wrap.setAttribute('data-nb-host-id', expected);
    return expected;
  }

  function bindHostMarker(host, tile, cart) {
    if (!host) return '';
    tile = tile || tileFromHost(host);
    if (tile && cart) {
      return rebindHostMarkerIfStale(host, tile, cart);
    }
    if (host.dataset.nbHostId) return host.dataset.nbHostId;
    var sib = host.nextElementSibling;
    if (sib && sib.classList && sib.classList.contains('nb-sub-overlay')) {
      var sid = sib.getAttribute('data-nb-host-id');
      if (sid) {
        host.dataset.nbHostId = sid;
        return sid;
      }
    }
    if (tile) {
      var overlays = tile.querySelectorAll('.nb-sub-overlay[data-nb-host-id]');
      if (overlays.length === 1) {
        var onlyId = overlays[0].getAttribute('data-nb-host-id');
        if (onlyId) {
          host.dataset.nbHostId = onlyId;
          if (overlays[0].previousElementSibling !== host) {
            host.insertAdjacentElement('afterend', overlays[0]);
          }
          return onlyId;
        }
      }
    }
    return hostMarker(host, tile, cart);
  }

  function lineUiKey(tile) {
    if (!tile) return '';
    var k = lineKeyFromTile(tile);
    if (k) return 'k:' + k;
    var li = lineIndexFromDom(tile);
    var plan = sellingPlanIdFromTile(tile);
    if (li) return plan ? 'l:' + li + ':p' + plan : 'l:' + li;
    var v = variantIdFromTile(tile);
    if (v) {
      var suffix = tileLooksSubscribedInDom(tile) ? 'sub' : 'otp';
      return plan ? 'v:' + v + ':' + suffix + ':p' + plan : 'v:' + v + ':' + suffix;
    }
    return '';
  }

  function isLikelySubscribedTile(host, tile, cart) {
    if (!host || !tile) return false;
    var ui = readLineUi(tile);
    if (ui && ui.unsubbed) return false;
    if (cart && cartStillHasSubscriptionForTile(tile, cart)) return true;
    var sel = findSubscriptionSelect(host, tile);
    if (sel && isSelectOnSubscriptionPlan(sel)) return true;
    if (ui && ui.activating) return true;
    if (
      ui &&
      ui.selected &&
      ui.expanded &&
      cart &&
      cartStillHasSubscriptionForTile(tile, cart)
    ) {
      return true;
    }
    if (host.classList.contains('nb-sub--selected') || host.hasAttribute('data-nb-expanded')) {
      return !!(cart && cartStillHasSubscriptionForTile(tile, cart));
    }
    return false;
  }

  function patchLineUi(tile, patch) {
    var key = lineUiKey(tile);
    if (!key) return;
    var cur = nbLineUi[key] || {};
    nbLineUi[key] = {
      selected: patch.selected !== undefined ? !!patch.selected : !!cur.selected,
      pending: patch.pending !== undefined ? !!patch.pending : !!cur.pending,
      expanded: patch.expanded !== undefined ? !!patch.expanded : !!cur.expanded,
      activating: patch.activating !== undefined ? !!patch.activating : !!cur.activating,
      deactivating: patch.deactivating !== undefined ? !!patch.deactivating : !!cur.deactivating,
      unsubbed: patch.unsubbed !== undefined ? !!patch.unsubbed : !!cur.unsubbed,
      freqChanging: patch.freqChanging !== undefined ? !!patch.freqChanging : !!cur.freqChanging,
      freqTargetIdx:
        patch.freqTargetIdx !== undefined
          ? patch.freqTargetIdx == null
            ? null
            : Number(patch.freqTargetIdx)
          : cur.freqTargetIdx != null
            ? Number(cur.freqTargetIdx)
            : null,
    };
  }

  function subscriptionOptionIndexFromCart(tile, cart, sel) {
    if (!tile || !cart || !sel || !sel.options) return -1;
    var ctx = cartLineForTile(tile, cart);
    if (!ctx) return -1;
    var planId = getSellingPlanIdFromCartItem(ctx.item);
    if (!planId) return -1;
    for (var i = 0; i < sel.options.length; i++) {
      var optPlan = sellingPlanIdFromSelectOption(sel.options[i], tile);
      if (optPlan && String(optPlan) === String(planId)) return i;
    }
    return -1;
  }

  function resolveActivePillIdx(wrap, sel, tile) {
    if (!sel || !sel.options || sel.selectedIndex < 0) return -1;
    var activeIdx = sel.selectedIndex;
    if (!tile) return activeIdx;
    var ui = readLineUi(tile);
    if (!ui || ui.freqTargetIdx == null || ui.freqTargetIdx < 0) return activeIdx;
    var targetIdx = Number(ui.freqTargetIdx);
    if (targetIdx < 0 || targetIdx >= sel.options.length) return activeIdx;
    var markerId =
      (wrap && wrap.getAttribute('data-nb-host-id')) ||
      (tile && hostFromTile(tile) && hostFromTile(tile).dataset.nbHostId) ||
      null;
    if (sel.selectedIndex === targetIdx) return targetIdx;
    if (ui.freqChanging || (markerId && nbFreqBusy[markerId])) return targetIdx;
    return activeIdx;
  }

  function clearFreqTargetIfSynced(tile, sel, cart) {
    if (!tile || !sel) return;
    var ui = readLineUi(tile);
    if (!ui || ui.freqTargetIdx == null) return;
    var targetIdx = Number(ui.freqTargetIdx);
    if (sel.selectedIndex === targetIdx) {
      patchLineUi(tile, { freqChanging: false, freqTargetIdx: null });
      return;
    }
    if (cart) {
      var cartIdx = subscriptionOptionIndexFromCart(tile, cart, sel);
      if (cartIdx >= 0 && cartIdx === targetIdx) {
        patchLineUi(tile, { freqChanging: false, freqTargetIdx: null });
      }
    }
  }

  function resetFreqTarget(tile) {
    if (!tile) return;
    patchLineUi(tile, { freqChanging: false, freqTargetIdx: null });
  }

  function findTileByLineUiKey(key) {
    if (!key) return null;
    var root = cartRoot() || document;
    var items = root.querySelectorAll('.upcart-public-cart-item,.upcart-internal-cart-item');
    for (var i = 0; i < items.length; i++) {
      if (lineUiKey(items[i]) === key) return items[i];
    }
    return null;
  }

  function resolveSubscribeContext(tile) {
    var key = lineUiKey(tile);
    if (!key) return null;
    var liveTile = tile && tile.isConnected ? tile : findTileByLineUiKey(key);
    if (!liveTile) return null;
    var liveHost = hostFromTile(liveTile);
    if (!liveHost) return null;
    return { key: key, tile: liveTile, host: liveHost };
  }

  function findSubscribeHostByMarkerId(hostId) {
    if (!hostId) return null;
    var root = cartRoot() || document;
    return (
      root.querySelector(
        '.upcart-public-component-product-tile__subscription-upgrade[data-nb-host-id="' + hostId + '"]'
      ) ||
      root.querySelector(
        '.upcart-internal-component-product-tile__subscription-upgrade[data-nb-host-id="' + hostId + '"]'
      )
    );
  }

  function migrateLineUiState(fromTile, toTile) {
    var oldKey = lineUiKey(fromTile);
    var newKey = lineUiKey(toTile);
    if (!oldKey || !newKey || oldKey === newKey) return;
    if (nbLineUi[oldKey]) {
      nbLineUi[newKey] = nbLineUi[oldKey];
      delete nbLineUi[oldKey];
    }
  }

  function hostFromFreqWrap(wrap) {
    if (!wrap) return null;
    var markerId = wrap.getAttribute('data-nb-host-id');
    if (markerId) {
      var byId = findSubscribeHostByMarkerId(markerId);
      if (byId && byId.isConnected) return byId;
    }
    var overlay = wrap.closest('.nb-sub-overlay');
    if (overlay) {
      var viaOverlay = findHostForOverlay(overlay);
      if (viaOverlay && viaOverlay.isConnected) return viaOverlay;
    }
    return null;
  }

  function ensureSubscribedWithPills(host, tile, cart) {
    if (!host || !tile || !host.isConnected) return false;
    bindHostMarker(host);
    patchLineUi(tile, {
      selected: true,
      expanded: true,
      pending: false,
      activating: false,
      deactivating: false,
      unsubbed: false,
    });
    ensureSubOverlay(host, tile);
    host.classList.add('nb-sub--ready', 'nb-sub--selected');
    host.classList.remove('nb-sub--has-btn');
    host.setAttribute('data-nb-expanded', 'true');
    var overlay = findSubOverlay(host);
    syncOverlayExpandedState(host, overlay);
    paintSubOverlay(host, tile);
    var sel = findSubscriptionSelect(host, tile);
    if (sel) {
      sel.classList.add('nb-sub-native-select');
      if (!rebuildFrequencyPills(host, tile)) {
        ensureFrequencyUI(host, tile, true);
      }
      syncLockedSubscriptionUi(host, tile, cart);
      return true;
    }
    if (cart && cartStillHasSubscriptionForTile(tile, cart)) {
      host.dataset.nbPollGen = String(Date.now());
      pollSelectUntilReady(host, tile, 30, host.dataset.nbPollGen);
      return true;
    }
    var ui = readLineUi(tile);
    if (ui && ui.selected && ui.expanded) {
      host.dataset.nbPollGen = String(Date.now());
      pollSelectUntilReady(host, tile, 30, host.dataset.nbPollGen);
      return true;
    }
    return false;
  }

  function cancelFreqSession(markerId) {
    var session = nbFreqSessions[markerId];
    if (!session) return;
    nbFreqLog('cancelFreqSession', { markerId: markerId, hadTimer: !!session.timer });
    if (session.timer) clearTimeout(session.timer);
    if (session.onCart) {
      document.removeEventListener('upcart:cartUpdated', session.onCart);
      document.removeEventListener('cart:updated', session.onCart);
    }
    delete nbFreqSessions[markerId];
  }

  function forceClearFreqPending(markerId, tileFallback) {
    cancelFreqSession(markerId);
    delete nbFreqBusy[markerId];
    var host = markerId ? findSubscribeHostByMarkerId(markerId) : null;
    var tile = host ? tileFromHost(host) : tileFallback;
    if (host && tile) syncSubscribeCardPendingUi(host, tile, false);
  }

  function completeFrequencyChange(markerId, token, liveHost, tile, source) {
    nbFreqLog('complete ENTER', {
      source: source || 'unknown',
      markerId: markerId,
      token: token,
      busyToken: nbFreqBusy[markerId],
      sessionDone: nbFreqSessions[markerId] && nbFreqSessions[markerId].done,
      snap: nbFreqSnapshot(markerId, liveHost, tile),
    });
    var session = nbFreqSessions[markerId];
    if (session && session.done) {
      nbFreqLog('complete ABORT already done', { markerId: markerId, source: source });
      return;
    }
    if (nbFreqBusy[markerId] !== token) {
      nbFreqLog('complete ABORT token mismatch', {
        markerId: markerId,
        source: source,
        expected: token,
        actual: nbFreqBusy[markerId],
      });
      return;
    }
    if (session) session.done = true;
    cancelFreqSession(markerId);
    delete nbFreqBusy[markerId];

    var failSources = {
      'not-subscribed': true,
      'no-plan-id': true,
      'api-fail': true,
      'cart-read-fail': true,
    };

    var h = findSubscribeHostByMarkerId(markerId) || liveHost;
    var t = h ? tileFromHost(h) : tile;
    if (t && failSources[source]) resetFreqTarget(t);
    if (t) patchLineUi(t, { pending: false });
    nbFreqLog('complete CLEAR pending', {
      source: source,
      markerId: markerId,
      hostFound: !!h,
      hostConnected: !!(h && h.isConnected),
      tileFound: !!t,
    });
    if (h && t) syncSubscribeCardPendingUi(h, t, false, 'complete:' + (source || 'unknown'));
    syncSubscribeCardPendingByMarker(markerId, false, 'complete:' + (source || 'unknown'));
    h = findSubscribeHostByMarkerId(markerId) || h;
    t = h ? tileFromHost(h) : t;
    if (h && t) {
      var selNow = findSubscriptionSelect(h, t);
      ensureSubscribedWithPills(h, t, nbCartCache);
      if (selNow) clearFreqTargetIfSynced(t, selNow, nbCartCache);
    }

    invalidateCartCache();
    getCartCached(0)
      .then(function (cart) {
        h = findSubscribeHostByMarkerId(markerId) || h;
        t = h ? tileFromHost(h) : t;
        if (h && t) {
          var selAfter = findSubscriptionSelect(h, t);
          ensureSubscribedWithPills(h, t, cart);
          if (selAfter) clearFreqTargetIfSynced(t, selAfter, cart);
        }
        nbFreqLog('complete rebuild after cart', {
          markerId: markerId,
          hostFound: !!h,
          hostConnected: !!(h && h.isConnected),
          hasSelect: !!(h && t && findSubscriptionSelect(h, t)),
        });
        burstResync();
      })
      .catch(function (err) {
        nbFreqLog('complete cart fetch failed', { markerId: markerId, err: err });
        if (h && t) {
          var selFail = findSubscriptionSelect(h, t);
          ensureSubscribedWithPills(h, t, nbCartCache);
          if (selFail) clearFreqTargetIfSynced(t, selFail, nbCartCache);
        }
      });
  }

  function handleFrequencyPillClick(button, wrap) {
    nbFreqLog('pill CLICK', {
      optIdx: button && button.getAttribute('data-opt-idx'),
      disabled: !!(button && button.disabled),
      wrapHostId: wrap && wrap.getAttribute('data-nb-host-id'),
    });
    var liveHost = hostFromFreqWrap(wrap);
    if (!liveHost) {
      nbFreqLog('pill ABORT no host');
      return;
    }
    var tile = tileFromHost(liveHost);
    if (!tile) {
      nbFreqLog('pill ABORT no tile');
      return;
    }
    bindHostMarker(liveHost);
    var markerId = liveHost.dataset.nbHostId;
    if (!markerId) {
      nbFreqLog('pill ABORT no markerId');
      return;
    }

    cancelFreqSession(markerId);
    delete nbFreqBusy[markerId];

    var sel = findSubscriptionSelect(liveHost, tile);
    if (!sel) {
      nbFreqLog('pill ABORT no select', nbFreqSnapshot(markerId, liveHost, tile));
      syncSubscribeCardPendingUi(liveHost, tile, false, 'pill:no-select');
      return;
    }
    var idx = Number(button.getAttribute('data-opt-idx'));
    if (idx < 0 || idx >= sel.options.length) {
      nbFreqLog('pill ABORT bad idx', { idx: idx, optionCount: sel.options.length });
      syncSubscribeCardPendingUi(liveHost, tile, false, 'pill:bad-idx');
      return;
    }

    markInteractCooldown(350);
    patchLineUi(tile, {
      pending: false,
      activating: false,
      deactivating: false,
      freqChanging: true,
      freqTargetIdx: idx,
    });
    var token = String(Date.now()) + '-' + String(Math.random()).slice(2, 8);
    nbFreqBusy[markerId] = token;
    nbFreqLog('pill START busy', {
      markerId: markerId,
      token: token,
      idx: idx,
      optionValue: sel.options[idx] && sel.options[idx].value,
      snap: nbFreqSnapshot(markerId, liveHost, tile),
    });
    syncSubscribeCardPendingUi(liveHost, tile, true, 'pill:start');
    syncSubscribeCardPendingByMarker(markerId, true, 'pill:start');

    var row = wrap.querySelector('.nb-sub-freq__row');
    if (row) {
      var all = row.querySelectorAll('button[data-opt-idx]');
      for (var j = 0; j < all.length; j++) {
        all[j].classList.toggle('is-active', Number(all[j].getAttribute('data-opt-idx')) === idx);
      }
    }

    var session = { token: token, timer: null, onCart: null, done: false };
    nbFreqSessions[markerId] = session;

    session.onCart = function () {
      nbFreqLog('pill cart event', { markerId: markerId, token: token });
      invalidateCartCache();
      setTimeout(function () {
        completeFrequencyChange(markerId, token, liveHost, tile, 'cart');
      }, 80);
    };
    document.addEventListener('upcart:cartUpdated', session.onCart);
    document.addEventListener('cart:updated', session.onCart);
    session.timer = setTimeout(function () {
      nbFreqLog('pill timer fired', { markerId: markerId, token: token });
      completeFrequencyChange(markerId, token, liveHost, tile, 'timer');
    }, 1800);

    nbFreqLog('pill applySelectOption BEFORE', { idx: idx, selectedBefore: sel.selectedIndex });
    var selectTriggered = applyFrequencySelectChange(liveHost, sel, idx);
    nbFreqLog('pill applySelectOption AFTER', {
      idx: idx,
      selectedAfter: sel.selectedIndex,
      selectTriggered: selectTriggered,
    });

    if (sel.selectedIndex !== idx) {
      scheduleFreqCartFallback(markerId, token, liveHost, tile, sel, idx);
    }
  }

  function ensureFreqDelegation() {
    if (nbFreqDelegationBound) return;
    nbFreqDelegationBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var root = cartRoot();
        if (!root) return;
        var clickEl = clickElementFromEvent(e);
        if (!clickEl || !root.contains(clickEl)) return;
        var b = clickEl.closest && clickEl.closest('.nb-sub-freq__row button[data-opt-idx]');
        if (!b || b.disabled) return;
        var wrap = b.closest('.nb-sub-freq');
        if (!wrap || !root.contains(wrap)) return;
        e.preventDefault();
        e.stopPropagation();
        handleFrequencyPillClick(b, wrap);
      },
      true
    );
  }

  function rebuildFrequencyPills(host, tile) {
    var sel = findSubscriptionSelect(host, tile);
    if (!sel || !host) return false;
    ensureFreqDelegation();
    var wrap = ensureFreqWrap(host);
    removeFreqLoadingUI(wrap);
    var row = wrap.querySelector('.nb-sub-freq__row');
    if (!row) return false;
    buildDynamicPillsRow(row, sel);
    syncPillsFromSelect(wrap, sel, tile);
    return true;
  }

  function readLineUi(tile) {
    var key = lineUiKey(tile);
    if (key && nbLineUi[key]) return nbLineUi[key];
    return null;
  }

  function pruneStaleLineUi(cart) {
    if (!cart || !cart.items) return;
    if (!cart.items.length) {
      nbLineUi = Object.create(null);
      return;
    }
    var liveKeys = Object.create(null);
    var i;
    for (i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key) liveKeys['k:' + String(cart.items[i].key)] = true;
    }
    var listEl = cartItemsListEl();
    if (listEl) {
      var lines = cartLineElements(listEl);
      for (i = 0; i < lines.length; i++) {
        var tk = lineUiKey(lines[i]);
        if (tk) liveKeys[tk] = true;
      }
    }
    for (var stale in nbLineUi) {
      if (!liveKeys[stale] || /^v:\d+$/.test(stale)) delete nbLineUi[stale];
    }
  }

  function findHostForOverlay(overlay) {
    if (!overlay || !overlay.isConnected) return null;
    var id = overlay.getAttribute('data-nb-host-id');
    if (!id) return null;
    var prev = overlay.previousElementSibling;
    if (
      prev &&
      prev.getAttribute &&
      prev.getAttribute('data-nb-host-id') === id &&
      (prev.classList.contains('upcart-public-component-product-tile__subscription-upgrade') ||
        prev.classList.contains('upcart-internal-component-product-tile__subscription-upgrade'))
    ) {
      return prev;
    }
    var root = cartRoot();
    var scope = root || document;
    var hosts = scope.querySelectorAll(
      '.upcart-public-component-product-tile__subscription-upgrade[data-nb-host-id="' +
        id +
        '"],.upcart-internal-component-product-tile__subscription-upgrade[data-nb-host-id="' +
        id +
        '"]'
    );
    return hosts.length ? hosts[0] : null;
  }

  function applyLineUiToHost(host, tile, cart) {
    var ui = readLineUi(tile);
    if (!ui) return false;
    var cartSub = cart ? cartStillHasSubscriptionForTile(tile, cart) : null;
    var showSelected = !!ui.selected && !ui.unsubbed;
    var showExpanded = !!ui.expanded && !ui.unsubbed;
    if (cartSub === false && !ui.activating && !ui.deactivating) {
      showSelected = false;
      showExpanded = false;
    }
    var showPending = !!(ui.pending && (ui.activating || ui.deactivating));
    if (showPending) {
      nbFreqLog('applyLineUiToHost pending=true', nbFreqSnapshot(host.dataset.nbHostId, host, tile));
    }
    host.classList.toggle('nb-sub--card-pending', showPending);
    host.classList.toggle('nb-sub--selected', showSelected);
    host.classList.add('nb-sub--ready');
    if (showExpanded) host.setAttribute('data-nb-expanded', 'true');
    else host.removeAttribute('data-nb-expanded');
    if (ui.activating) host.dataset.nbActivating = '1';
    else if (host.dataset.nbActivating) delete host.dataset.nbActivating;
    if (ui.deactivating) {
      host.dataset.nbSubBusy = '1';
    } else if (host.dataset.nbSubBusy && host.dataset.nbExpandBusy !== '1') {
      delete host.dataset.nbSubBusy;
    }
    ensureSubOverlay(host, tile);
    syncSubscribeCardPendingUi(host, tile, showPending, 'applyLineUiToHost');
    syncOverlayExpandedState(host, findSubOverlay(host));
    return true;
  }

  function syncSubscribeCardPendingByMarker(markerId, pending, reason) {
    if (!markerId) return;
    var root = cartRoot() || document;
    var host = findSubscribeHostByMarkerId(markerId);
    if (host) host.classList.toggle('nb-sub--card-pending', !!pending);
    var overlays = root.querySelectorAll('.nb-sub-overlay[data-nb-host-id="' + markerId + '"]');
    for (var o = 0; o < overlays.length; o++) {
      var overlay = overlays[o];
      overlay.classList.toggle('nb-sub-overlay--pending', !!pending);
      overlay.setAttribute('aria-busy', pending ? 'true' : 'false');
      var syncEl = overlay.querySelector('.nb-sub__sync');
      if (syncEl) syncEl.classList.toggle('nb-sub__sync--spin', !!pending);
      var wrap = overlay.querySelector('.nb-sub-freq[data-nb-host-id="' + markerId + '"]');
      if (wrap) {
        wrap.classList.toggle('nb-sub-freq--busy', !!pending);
        var pills = wrap.querySelectorAll('.nb-sub-freq__row button');
        for (var p = 0; p < pills.length; p++) {
          pills[p].disabled = !!pending;
        }
      }
    }
    if (reason && pending && window.NB_UPCART_SUBSCRIBE_DEBUG === true) {
      nbFreqLog('syncPendingByMarker ON', { markerId: markerId, reason: reason });
    }
  }

  function syncSubscribeCardPendingUi(host, tile, pending, reason) {
    if (!host || !tile) {
      nbFreqLog('syncPending SKIP no host/tile', { pending: pending, reason: reason });
      return;
    }
    var markerId = host.dataset.nbHostId || bindHostMarker(host);
    host.classList.toggle('nb-sub--card-pending', !!pending);
    var overlay = findSubOverlay(host);
    if (!overlay) {
      ensureSubOverlay(host, tile);
      overlay = findSubOverlay(host);
    }
    if (!overlay) {
      nbFreqLog('syncPending SKIP no overlay', {
        pending: pending,
        reason: reason,
        markerId: markerId,
        hostConnected: host.isConnected,
      });
      return;
    }
    if (window.NB_UPCART_SUBSCRIBE_DEBUG === true) {
      nbFreqLog('syncPending ' + (pending ? 'ON' : 'OFF'), {
        reason: reason || 'unknown',
        markerId: markerId,
        hostConnected: host.isConnected,
      });
    }
    overlay.classList.toggle('nb-sub-overlay--pending', !!pending);
    overlay.setAttribute('aria-busy', pending ? 'true' : 'false');
    var syncEl = overlay.querySelector('.nb-sub__sync');
    if (syncEl) syncEl.classList.toggle('nb-sub__sync--spin', !!pending);
    var wrap = findFreqWrap(host);
    if (wrap) {
      wrap.classList.toggle('nb-sub-freq--busy', !!pending);
      var pills = wrap.querySelectorAll('.nb-sub-freq__row button');
      for (var p = 0; p < pills.length; p++) {
        pills[p].disabled = !!pending;
      }
    }
  }

  function findSubOverlay(host) {
    if (!host || !host.isConnected) return null;
    var id = host.dataset.nbHostId || bindHostMarker(host);
    var scopes = [host.parentElement, cartRoot(), document.getElementById('CartPopup')];
    var s;
    for (s = 0; s < scopes.length; s++) {
      var scope = scopes[s];
      if (!scope) continue;
      var match = scope.querySelector('.nb-sub-overlay[data-nb-host-id="' + id + '"]');
      if (match) {
        if (match.previousElementSibling !== host) {
          host.insertAdjacentElement('afterend', match);
        }
        return match;
      }
    }
    var sib = host.nextElementSibling;
    while (sib && sib.classList && sib.classList.contains('nb-sub-overlay')) {
      var orphan = sib;
      sib = sib.nextElementSibling;
      if (orphan.getAttribute('data-nb-host-id') !== id) safeRemoveNode(orphan);
    }
    return null;
  }

  function subOverlayInnerHtml() {
    return (
      '<div class="nb-sub-static-card__inner">' +
      '<span class="nb-sub__lead" aria-hidden="true">' +
      markLeadInnerHtml() +
      syncIconSvg() +
      '</span>' +
      '<span class="nb-sub__mid">' +
      '<span class="nb-sub__title">Subscribe &amp; Save</span>' +
      '<span class="nb-sub__sub">' +
      '<span class="nb-sub__sub-line"></span>' +
      '<span class="nb-sub__sub-gift"></span>' +
      '</span>' +
      '</span>' +
      '<span class="nb-sub__price" aria-hidden="true"></span>' +
      '</div>'
    );
  }

  function paintSubOverlay(host, tile, cart) {
    cart = cart == null ? nbCartCache : cart;
    var overlay = findSubOverlay(host);
    if (!overlay) return null;
    var inner = overlay.querySelector('.nb-sub-static-card__inner');
    if (!inner) {
      overlay.innerHTML = subOverlayInnerHtml();
      inner = overlay.querySelector('.nb-sub-static-card__inner');
    }
    if (inner) {
      var sub = inner.querySelector('.nb-sub__sub');
      var price = inner.querySelector('.nb-sub__price');
      if (sub) paintSubCopyEl(sub, tile, host, cart);
      if (price) {
        price.textContent = parseSubscribePrice(tile, host, cart);
        refreshSubscribePriceAsync(host, tile, cart);
      }
    }
    return overlay;
  }

  function ensureSubOverlay(host, tile) {
    if (!host || !host.isConnected || !tile) return null;
    bindHostMarker(host);
    var overlay = findSubOverlay(host);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'nb-sub-overlay';
      overlay.setAttribute('data-nb-host-id', host.dataset.nbHostId);
      overlay.setAttribute('aria-hidden', 'true');
      host.insertAdjacentElement('afterend', overlay);
      overlay.innerHTML = subOverlayInnerHtml();
      paintSubOverlay(host, tile);
    } else {
      paintSubOverlay(host, tile);
    }
    ensureOverlayToggle(host, overlay);
    syncOverlayExpandedState(host, overlay);
    return overlay;
  }

  function ensureOverlayToggle(host, overlay) {
    if (!host || !overlay) return;
    if (overlay.dataset.nbOverlayToggle === '1') return;
    overlay.dataset.nbOverlayToggle = '1';
    overlay.setAttribute('role', 'button');
    overlay.setAttribute('tabindex', '0');
    overlay.addEventListener('click', function (e) {
      var liveHost = findHostForOverlay(overlay) || host;
      if (liveHost) handleSubscribeToggleClick(liveHost, e);
    });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var liveHost = findHostForOverlay(overlay) || host;
        if (liveHost) handleSubscribeToggleClick(liveHost, e);
      }
    });
  }

  function isSubscribeUiActive(host) {
    if (!host) return false;
    var tile = tileFromHost(host);
    var ui = tile ? readLineUi(tile) : null;
    if (ui && ui.unsubbed) return false;
    if (host.dataset.nbExpandBusy === '1' || host.dataset.nbSubBusy === '1') return true;
    if (host.dataset.nbActivating === '1' || host.hasAttribute('data-nb-expanded')) return true;
    if (ui && ui.deactivating) return true;
    if (nbCartCache && tile && cartStillHasSubscriptionForTile(tile, nbCartCache)) return true;
    if (isSubscribedSelectOnly(host)) {
      return isSelectOnSubscriptionPlan(findSubscriptionSelect(host, tile));
    }
    return false;
  }

  function runUnsubscribe(host, tile, btn) {
    if (shouldBlockUnsubscribe(host, tile, nbCartCache)) return;
    if (host.dataset.nbSubBusy === '1') return;
    markInteractCooldown(400);
    host.dataset.nbSubBusy = '1';
    markUnsubPending(host);
    patchLineUi(tile, {
      selected: true,
      pending: true,
      expanded: true,
      activating: false,
      deactivating: true,
      unsubbed: false,
    });
    ensureSubOverlay(host, tile);
    syncSubscribeCardPendingUi(host, tile, true);
    burstResync();
    switchLineToOneTimePurchase(tile, host)
      .then(function (result) {
        var liveHost = host.isConnected ? host : hostFromTile(tile);
        if (!result || result.ok === false) {
          clearUnsubDone(liveHost || host);
          clearUnsubPending(liveHost || host);
          patchLineUi(tile, {
            pending: false,
            deactivating: false,
            unsubbed: false,
            selected: true,
            expanded: true,
          });
          if (liveHost) syncSubscribeCardPendingUi(liveHost, tile, false);
          burstResync();
          return;
        }
        if (liveHost) markUnsubDone(liveHost);
        else markUnsubDone(host);
        clearUnsubPending(liveHost || host);
        resetSubscribeUiState(liveHost || host, tile, btn, true);
        patchLineUi(tile, {
          selected: false,
          pending: false,
          expanded: false,
          deactivating: false,
          unsubbed: true,
        });
        if (liveHost) syncSubscribeCardPendingUi(liveHost, tile, false);
        burstResync();
      })
      .finally(function () {
        var liveHost = host.isConnected ? host : hostFromTile(tile);
        if (liveHost) {
          delete liveHost.dataset.nbSubBusy;
        } else {
          delete host.dataset.nbSubBusy;
        }
        patchLineUi(tile, { pending: false, deactivating: false });
        burstResync();
      });
  }

  function runSubscribeFromSelect(host, tile, sel) {
    clearUnsubPending(host);
    clearUnsubDone(host);
    patchLineUi(tile, { unsubbed: false, deactivating: false });
    if (host.dataset.nbExpandBusy === '1' || host.dataset.nbSubBusy === '1') return;
    var subIdx = firstSubscriptionOptionIndex(sel);
    if (subIdx < 0) return;
    markInteractCooldown(400);
    host.dataset.nbActivating = '1';
    patchLineUi(tile, { selected: true, pending: true, expanded: true, activating: true });
    host.dataset.nbExpandBusy = '1';
    host.dataset.nbPollGen = String(Date.now());
    host.setAttribute('data-nb-expanded', 'true');
    host.classList.add('nb-sub--selected');
    ensureSubOverlay(host, tile);
    syncOverlayExpandedState(host, findSubOverlay(host));
    syncSubscribeCardPendingUi(host, tile, true);
    applySelectOption(sel, subIdx);
    burstResync();
    requestAnimationFrame(function () {
      try {
        if (!host.isConnected) return;
        var t2 = tileFromHost(host) || tile;
        ensureFrequencyUI(host, t2, true);
        pollSelectUntilReady(host, t2, 45, host.dataset.nbPollGen);
      } finally {
        delete host.dataset.nbExpandBusy;
        var tDone = tileFromHost(host) || tile;
        waitForSubscriptionInCart(tDone, 25, 160).then(function (subscribed) {
          var liveHost = host.isConnected ? host : hostFromTile(tDone);
          if (subscribed) {
            if (liveHost) delete liveHost.dataset.nbActivating;
            else delete host.dataset.nbActivating;
            patchLineUi(tDone, { pending: false, selected: true, expanded: true, activating: false });
          } else {
            patchLineUi(tDone, { pending: false, selected: true, expanded: true, activating: true });
          }
          if (liveHost) syncSubscribeCardPendingUi(liveHost, tDone, false);
          getCartCached(0).then(function (freshCart) {
            syncCartItemsOrder(freshCart);
            burstResync();
          });
        });
      }
    });
  }

  function runSubscribeExpand(host, tile, btn) {
    clearUnsubPending(host);
    clearUnsubDone(host);
    patchLineUi(tile, { unsubbed: false, deactivating: false });
    if (host.dataset.nbExpandBusy === '1') return;
    markInteractCooldown(400);
    host.dataset.nbActivating = '1';
    patchLineUi(tile, { selected: true, pending: true, expanded: true, activating: true });
    host.dataset.nbExpandBusy = '1';
    host.dataset.nbPollGen = String(Date.now());
    host.setAttribute('data-nb-expanded', 'true');
    host.classList.add('nb-sub--selected');
    if (btn) btn.setAttribute('aria-pressed', 'true');
    ensureSubOverlay(host, tile);
    syncOverlayExpandedState(host, findSubOverlay(host));
    syncSubscribeCardPendingUi(host, tile, true);
    burstResync();
    requestAnimationFrame(function () {
      try {
        if (!host.isConnected) return;
        var t2 = tileFromHost(host);
        if (t2) {
          syncUpgradePresentation(host, t2, nbCartCache);
          ensureFrequencyUI(host, t2, false);
          pollSelectUntilReady(host, t2, 45, host.dataset.nbPollGen);
        }
      } finally {
        delete host.dataset.nbExpandBusy;
        var tDone = tileFromHost(host) || tile;
        waitForSubscriptionInCart(tDone, 25, 160).then(function (subscribed) {
          var liveHost = host.isConnected ? host : hostFromTile(tDone);
          if (subscribed) {
            if (liveHost) delete liveHost.dataset.nbActivating;
            else delete host.dataset.nbActivating;
            patchLineUi(tDone, { pending: false, selected: true, expanded: true, activating: false });
          } else {
            patchLineUi(tDone, { pending: false, selected: true, expanded: true, activating: true });
          }
          if (liveHost) syncSubscribeCardPendingUi(liveHost, tDone, false);
          getCartCached(0).then(function (freshCart) {
            syncCartItemsOrder(freshCart);
            burstResync();
          });
        });
      }
    });
  }

  function clickElementFromEvent(e) {
    if (!e || !e.target) return null;
    if (e.target.nodeType === 1) return e.target;
    return e.target.parentElement || null;
  }

  function handleSubscribeToggleClick(host, e) {
    if (host.dataset.nbProgrammaticNative === '1') return;

    var clickEl = clickElementFromEvent(e);
    if (clickEl && clickEl.closest && clickEl.closest('.nb-sub-freq')) return;

    var tile = tileFromHost(host);
    if (!tile) return;

    if (isSubscribeUiActive(host)) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
      if (shouldBlockUnsubscribe(host, tile, nbCartCache)) return;
      runUnsubscribe(host, tile, upgradeBtn(host));
      return;
    }

    var btn = upgradeBtn(host);
    if (btn) {
      runSubscribeExpand(host, tile, btn);
      if (e && e.type === 'keydown') {
        requestAnimationFrame(function () {
          host.dataset.nbProgrammaticNative = '1';
          try {
            if (btn.isConnected) btn.click();
          } catch (err) {}
          delete host.dataset.nbProgrammaticNative;
        });
      }
      return;
    }

    var sel = findSubscriptionSelect(host, tile);
    if (sel && firstSubscriptionOptionIndex(sel) >= 0) {
      runSubscribeFromSelect(host, tile, sel);
    }
  }

  function removeSubOverlay(host) {
    safeRemoveNode(findSubOverlay(host));
  }

  function purgeLegacyInjections(host) {
    if (!host) return;
    safeRemoveNode(host.querySelector('.nb-sub-static-card'));
    safeRemoveNode(host.querySelector('.nb-sub-freq'));
  }

  function syncUpgradePresentation(host, tile, cart) {
    if (!host || !host.isConnected || !tile) return;
    if (host.dataset.nbExpandBusy === '1') return;
    if (host.dataset.nbSubBusy === '1') return;

    purgeLegacyInjections(host);
    var showSelected = shouldShowSubscribeSelected(host, tile, cart);

    if (isSubscribedSelectOnly(host)) {
      host.classList.remove('nb-sub--has-btn');
      ensureSubOverlay(host, tile);
      host.classList.add('nb-sub--ready');
      host.classList.toggle('nb-sub--selected', showSelected);
      if (!showSelected) host.removeAttribute('data-nb-expanded');
      syncOverlayExpandedState(host, findSubOverlay(host));
      syncLockedSubscriptionUi(host, tile, cart);
      return;
    }

    var btn = upgradeBtn(host);
    if (!btn) return;

    var orig =
      btn.getAttribute('aria-label') ||
      btn.getAttribute('data-nb-subscription-label') ||
      (btn.textContent && btn.textContent.trim());
    if (orig) {
      btn.setAttribute('aria-label', orig);
      btn.setAttribute('data-nb-subscription-label', orig);
    }

    ensureSubOverlay(host, tile);
    host.classList.add('nb-sub--ready', 'nb-sub--has-btn');

    if (showSelected) {
      host.classList.add('nb-sub--selected');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      host.classList.remove('nb-sub--selected');
      host.removeAttribute('data-nb-expanded');
      btn.setAttribute('aria-pressed', 'false');
    }
    syncOverlayExpandedState(host, findSubOverlay(host));
    syncLockedSubscriptionUi(host, tile, cart);
  }

  function ensureSubscribedStaticCard(host, tile) {
    ensureSubOverlay(host, tile);
    host.classList.add('nb-sub--ready', 'nb-sub--selected');
    host.classList.remove('nb-sub--has-btn');
  }

  function ensureUncheckedSubscribeCard(host, tile) {
    ensureSubOverlay(host, tile);
    host.classList.add('nb-sub--ready');
    host.classList.remove('nb-sub--selected', 'nb-sub--has-btn');
  }

  function removeStaleStaticCard(host) {
    if (!host) return;
    purgeLegacyInjections(host);
    removeSubOverlay(host);
    host.classList.remove('nb-sub--has-btn');
  }

  function syncPillsFromSelect(wrap, sel, tile) {
    var row = wrap.querySelector('.nb-sub-freq__row');
    if (!row || !sel || !sel.options) return;
    var activeIdx = resolveActivePillIdx(wrap, sel, tile);
    if (activeIdx < 0) activeIdx = sel.selectedIndex;
    var buttons = row.querySelectorAll('button[data-opt-idx]');
    for (var i = 0; i < buttons.length; i++) {
      var idx = Number(buttons[i].getAttribute('data-opt-idx'));
      buttons[i].classList.toggle('is-active', idx === activeIdx);
    }
    if (tile) clearFreqTargetIfSynced(tile, sel, nbCartCache);
  }

  function buildDynamicPillsRow(row, sel) {
    row.innerHTML = '';
    for (var i = 0; i < sel.options.length; i++) {
      var opt = sel.options[i];
      if (opt.disabled) continue;
      if (isOneTimePurchaseOption(opt)) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-opt-idx', String(i));
      b.textContent = pillLabelFromOption(opt);
      row.appendChild(b);
    }
  }

  function removeFreqLoadingUI(wrap) {
    if (!wrap) return;
    var rm = wrap.querySelectorAll('.nb-sub-freq__loading, .nb-sub-freq__skeleton');
    for (var r = 0; r < rm.length; r++) {
      safeRemoveNode(rm[r]);
    }
    wrap.classList.remove('nb-sub-freq--waiting');
  }

  function ensureFreqLoadingPlaceholder(wrap) {
    if (!wrap || wrap.querySelector('.nb-sub-freq__skeleton')) return;
    wrap.classList.add('nb-sub-freq--waiting');
    var sk = document.createElement('div');
    sk.className = 'nb-sub-freq__skeleton';
    sk.setAttribute('role', 'status');
    sk.setAttribute('aria-live', 'polite');
    sk.setAttribute('aria-label', 'Loading delivery options');
    sk.innerHTML =
      '<div class="nb-sub-freq__skel-pill"></div>' +
      '<div class="nb-sub-freq__skel-pill"></div>' +
      '<div class="nb-sub-freq__skel-pill"></div>' +
      '<div class="nb-sub-freq__skel-pill"></div>';
    var label = wrap.querySelector('.nb-sub-freq__label');
    if (label) {
      label.insertAdjacentElement('afterend', sk);
    } else {
      wrap.insertBefore(sk, wrap.firstChild);
    }
  }

  function pollSelectUntilReady(host, tile, attemptsLeft, pollGen) {
    if (!host || !host.isConnected) return;
    if (pollGen && host.dataset.nbPollGen !== pollGen) return;
    var t = tileFromHost(host) || tile;
    if (!t) return;
    if (attemptsLeft <= 0) {
      removeFreqLoadingUI(findFreqWrap(host));
      delete host.dataset.nbActivating;
      patchLineUi(t, { pending: false, activating: false });
      syncSubscribeCardPendingUi(host, t, false, 'pollSelect:timeout');
      return;
    }
    var selNow = findSubscriptionSelect(host, t);
    if (selNow) {
      removeFreqLoadingUI(findFreqWrap(host));
      if (!rebuildFrequencyPills(host, t)) {
        ensureFrequencyUI(host, t, isSubscribedSelectOnly(host));
      }
      if (cartStillHasSubscriptionForTile(t, nbCartCache)) {
        delete host.dataset.nbActivating;
        patchLineUi(t, { pending: false, selected: true, expanded: true, activating: false });
      }
      paintSubOverlay(host, t, nbCartCache);
      return;
    }
    setTimeout(function () {
      if (!host.isConnected) return;
      if (pollGen && host.dataset.nbPollGen !== pollGen) return;
      pollSelectUntilReady(host, t, attemptsLeft - 1, pollGen);
    }, 175);
  }

  /** Freq block lives inside our overlay (avoids layout jump as sibling). */
  function findFreqWrap(host) {
    if (!host || !host.isConnected) return null;
    var legacy = host.querySelector('.nb-sub-freq');
    if (legacy) safeRemoveNode(legacy);
    var id = host.dataset.nbHostId;
    if (!id) return null;
    var overlay = findSubOverlay(host);
    if (overlay) {
      var inOverlay = overlay.querySelector('.nb-sub-freq[data-nb-host-id="' + id + '"]');
      if (inOverlay) return inOverlay;
    }
    var parent = host.parentElement;
    if (!parent) return null;
    var orphan = parent.querySelector('.nb-sub-freq[data-nb-host-id="' + id + '"]');
    if (orphan && overlay) {
      overlay.appendChild(orphan);
      return orphan;
    }
    return orphan;
  }

  function ensureFreqWrap(host) {
    bindHostMarker(host);
    var wrap = findFreqWrap(host);
    if (wrap) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'nb-sub-freq';
    wrap.setAttribute('data-nb-host-id', host.dataset.nbHostId);
    wrap.innerHTML =
      '<span class="nb-sub-freq__label">Delivery frequency:</span>' +
      '<div class="nb-sub-freq__row" role="group" aria-label="Delivery frequency"></div>';
    var overlay = findSubOverlay(host);
    if (overlay) {
      overlay.appendChild(wrap);
      syncOverlayExpandedState(host, overlay);
    } else {
      host.insertAdjacentElement('afterend', wrap);
    }
    return wrap;
  }

  function removeFreqUI(host) {
    safeRemoveNode(findFreqWrap(host));
  }

  function stripNativeSelectMarks(tile) {
    if (!tile) return;
    var marked = tile.querySelectorAll('select.nb-sub-native-select');
    for (var k = 0; k < marked.length; k++) {
      marked[k].classList.remove('nb-sub-native-select');
    }
  }

  function attachFreqWrapListeners(wrap, host) {
    ensureFreqDelegation();
  }

  /**
   * @param {boolean} subscribedOnly - true when UpCart replaced button with plan <select>
   */
  function ensureFrequencyUI(host, tile, subscribedOnly) {
    var sel = findSubscriptionSelect(host, tile);
    var expanded = host.hasAttribute('data-nb-expanded');

    if (subscribedOnly) {
      if (!sel) return;
      sel.classList.add('nb-sub-native-select');
      host.classList.add('nb-sub--ready', 'nb-sub--selected');
      var wrap = ensureFreqWrap(host);
      attachFreqWrapListeners(wrap, host);
      removeFreqLoadingUI(wrap);
      var row = wrap.querySelector('.nb-sub-freq__row');
      var wantPills = countSubscriptionPillOptions(sel);
      if (row && !row.querySelector('button')) {
        buildDynamicPillsRow(row, sel);
      } else if (row && row.querySelector('button[data-opt-idx]')) {
        var have = row.querySelectorAll('button[data-opt-idx]').length;
        if (have !== wantPills) buildDynamicPillsRow(row, sel);
      }
      syncPillsFromSelect(wrap, sel, tile);
      return;
    }

    if (!expanded && !subscribedOnly) {
      if (host.dataset.nbActivating === '1' || host.hasAttribute('data-nb-expanded')) {
        host.classList.add('nb-sub--selected');
        var wrapPending = ensureFreqWrap(host);
        attachFreqWrapListeners(wrapPending, host);
        ensureFreqLoadingPlaceholder(wrapPending);
        syncOverlayExpandedState(host, findSubOverlay(host));
        return;
      }
      host.classList.remove('nb-sub--selected');
      removeFreqUI(host);
      stripNativeSelectMarks(tile);
      var ubtn = upgradeBtn(host);
      if (ubtn) ubtn.setAttribute('aria-pressed', 'false');
      syncOverlayExpandedState(host, findSubOverlay(host));
      return;
    }

    host.classList.add('nb-sub--selected');
    var btn = upgradeBtn(host);
    if (btn) btn.setAttribute('aria-pressed', 'true');
    if (sel) sel.classList.add('nb-sub-native-select');

    var wrap2 = ensureFreqWrap(host);
    var row2 = wrap2.querySelector('.nb-sub-freq__row');
    attachFreqWrapListeners(wrap2, host);
    if (row2 && sel && sel.options.length) {
      removeFreqLoadingUI(wrap2);
      var n = row2.querySelectorAll('button[data-opt-idx]').length;
      var want = countSubscriptionPillOptions(sel);
      if (n !== want) {
        buildDynamicPillsRow(row2, sel);
      }
      syncPillsFromSelect(wrap2, sel, tile);
    } else {
      ensureFreqLoadingPlaceholder(wrap2);
    }
    syncOverlayExpandedState(host, findSubOverlay(host));
  }

  function ensureSubscribeToggle(host) {
    if (host.dataset.nbToggle === '1') return;
    host.dataset.nbToggle = '1';
    host.addEventListener(
      'click',
      function (e) {
        handleSubscribeToggleClick(host, e);
      },
      true
    );
  }

  function enhanceHost(host, cart) {
    if (!host || !host.isConnected) return;
    var tile = tileFromHost(host);
    if (!tile) return;

    rebindHostMarkerIfStale(host, tile, cart);

    if (cart) reconcileLineUiFromCart(tile, cart);

    var hadLineUi = applyLineUiToHost(host, tile, cart);

    if (cart && !shouldPreserveSubscribeUi(host, tile, cart)) {
      if (!cartStillHasSubscriptionForTile(tile, cart)) {
        host.removeAttribute('data-nb-expanded');
        host.classList.remove('nb-sub--selected');
        delete host.dataset.nbActivating;
      }
    }

    var btn = upgradeBtn(host);
    var sel = findSubscriptionSelect(host, tile);
    var subOnly = !btn && !!sel;
    var cartSub = cart ? cartStillHasSubscriptionForTile(tile, cart) : false;

    if (
      host.dataset.nbSubBusy === '1' ||
      host.dataset.nbExpandBusy === '1' ||
      (readLineUi(tile) && readLineUi(tile).deactivating)
    ) {
      if (hadLineUi || btn || subOnly) ensureSubscribeToggle(host);
      return;
    }

    var hostMarkerId = bindHostMarker(host, tile, cart);
    if (hostMarkerId && nbFreqBusy[hostMarkerId]) {
      nbFreqLog('enhanceHost re-apply busy', {
        markerId: hostMarkerId,
        busyToken: nbFreqBusy[hostMarkerId],
        snap: nbFreqSnapshot(hostMarkerId, host, tile),
      });
      ensureSubscribeToggle(host);
      syncSubscribeCardPendingUi(host, tile, true, 'enhanceHost:nbFreqBusy');
      if (isLikelySubscribedTile(host, tile, cart)) {
        ensureSubscribedWithPills(host, tile, cart);
      }
      syncLockedSubscriptionUi(host, tile, cart);
      return;
    }

    if (cart && cartSub && tileHasLockedSubscription(tile, cart)) {
      clearUnsubPending(host);
      clearUnsubDone(host);
      patchLineUi(tile, {
        unsubbed: false,
        deactivating: false,
        selected: true,
        expanded: true,
        pending: false,
        activating: false,
      });
      ensureSubscribedWithPills(host, tile, cart);
      syncLockedSubscriptionUi(host, tile, cart);
      ensureSubscribeToggle(host);
      return;
    }

    if (btn) {
      clearUnsubPending(host);
      clearUnsubDone(host);
      patchLineUi(tile, { unsubbed: false, deactivating: false });
      purgeLegacyInjections(host);
      if (cart && !cartSub && !shouldPreserveSubscribeUi(host, tile, cart)) {
        removeFreqUI(host);
        showUncheckedSubscribeUi(host, tile);
      } else {
        syncUpgradePresentation(host, tile, cart);
        ensureFrequencyUI(host, tile, false);
      }
      ensureSubscribeToggle(host);
      syncLockedSubscriptionUi(host, tile, cart);
    } else if (subOnly) {
      var lineUi = readLineUi(tile);
      if (lineUi && lineUi.deactivating) {
        ensureSubscribeToggle(host);
        syncSubscribeCardPendingUi(host, tile, true);
        return;
      }
      if (lineUi && lineUi.unsubbed) {
        showUncheckedSubscribeUi(host, tile);
        ensureSubscribeToggle(host);
        return;
      }
      if (host.dataset.nbSubBusy === '1' || (lineUi && lineUi.deactivating)) {
        nbFreqLog('enhanceHost subOnly pending branch', {
          nbSubBusy: host.dataset.nbSubBusy === '1',
          deactivating: !!(lineUi && lineUi.deactivating),
          snap: nbFreqSnapshot(host.dataset.nbHostId, host, tile),
        });
        ensureSubscribeToggle(host);
        syncSubscribeCardPendingUi(host, tile, true, 'enhanceHost:subOnly-pending');
        if (host.dataset.nbUnsubPending === '1') {
          verifyUnsubStateAgainstCart(host, tile);
        }
        return;
      }
      if (host.dataset.nbUnsubDone === '1') {
        showUncheckedSubscribeUi(host, tile);
        ensureSubscribeToggle(host);
        return;
      }
      if (!isLikelySubscribedTile(host, tile, cart)) {
        if (lineUi && lineUi.selected && lineUi.expanded && !lineUi.unsubbed) {
          ensureSubscribedWithPills(host, tile, cart);
          ensureSubscribeToggle(host);
          return;
        }
        showUncheckedSubscribeUi(host, tile);
        return;
      }
      ensureSubscribedWithPills(host, tile, cart);
      ensureSubscribeToggle(host);
      syncLockedSubscriptionUi(host, tile, cart);
    } else {
      var lineUiElse = readLineUi(tile);
      if (lineUiElse && lineUiElse.selected && lineUiElse.expanded && !lineUiElse.unsubbed) {
        ensureSubscribeToggle(host);
        ensureSubscribedWithPills(host, tile, cart);
        return;
      }
      clearUnsubPending(host);
      clearUnsubDone(host);
      removeStaleStaticCard(host);
      host.classList.remove('nb-sub--ready', 'nb-sub--selected');
      removeFreqUI(host);
      stripNativeSelectMarks(tile);
    }
  }

  var debounceTimer = null;
  var popupObserver = null;
  var observedEl = null;

  function detachObs() {
    if (popupObserver) {
      popupObserver.disconnect();
      popupObserver = null;
    }
    observedEl = null;
  }

  function attachObs(el) {
    if (observedEl === el && popupObserver) return;
    detachObs();
    observedEl = el;
    popupObserver = new MutationObserver(function () {
      scheduleScan();
    });
    popupObserver.observe(el, { childList: true, subtree: true });
  }

  function flushScan() {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    scan();
  }

  function burstResync() {
    flushScan();
    requestAnimationFrame(flushScan);
    setTimeout(flushScan, 48);
    setTimeout(flushScan, 120);
  }

  function scheduleScan() {
    if (debounceTimer) clearTimeout(debounceTimer);
    var delay = SCAN_DEBOUNCE_MS;
    if (isInteractCooldown()) {
      delay = Math.max(delay, nbInteractUntil - Date.now() + 50);
    }
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      scan();
    }, delay);
  }

  /* NB-014-AB */
  function isGiftCartItem(item) {
    return !!(item && item.properties && String(item.properties.__upcartFreeGift) === 'true');
  }

  function giftValueCents(item, tile) {
    if (item) {
      var compare = Number(item.compare_at_price);
      if (compare > 0) return compare;
      var original = Number(item.original_price);
      var finalPrice = Number(item.final_price);
      if (original > 0 && (finalPrice === 0 || isNaN(finalPrice))) return original;
      var originalLine = Number(item.original_line_price);
      var finalLine = Number(item.final_line_price);
      if (originalLine > 0 && (finalLine === 0 || isNaN(finalLine))) {
        return Math.round(originalLine / Math.max(Number(item.quantity) || 1, 1));
      }
      var discount = Number(item.total_discount);
      if (discount > 0) return Math.round(discount / Math.max(Number(item.quantity) || 1, 1));
      var price = Number(item.price);
      if (price > 0 && finalPrice === 0) return price;
    }
    if (tile) {
      var compareEl = tile.querySelector('[data-upcart-chunk="cart-item-compare-at-price"]');
      var fromCompare = parseMoneyToNumber(compareEl ? compareEl.textContent : '');
      if (fromCompare != null && fromCompare > 0) return Math.round(fromCompare * 100);
      var savingsEl = tile.querySelector('[data-upcart-chunk="cart-item-savings"]');
      var fromSave = parseMoneyToNumber(savingsEl ? savingsEl.textContent : '');
      if (fromSave != null && fromSave > 0) return Math.round(fromSave * 100);
      var priceEl = tile.querySelector('[data-upcart-chunk="cart-item-price"]');
      var fromPrice = parseMoneyToNumber(priceEl ? priceEl.textContent : '');
      if (fromPrice != null && fromPrice > 0) return Math.round(fromPrice * 100);
    }
    return 0;
  }

  function formatGiftMoney(cents) {
    var n = Number(cents);
    if (!n || isNaN(n) || n <= 0) return '';
    return '$' + (n / 100).toFixed(2);
  }

  function productTileFromCartLine(li) {
    if (!li) return null;
    return (
      li.querySelector('.upcart-public-component-product-tile') ||
      li.querySelector('.upcart-internal-component-product-tile') ||
      li
    );
  }

  function giftPriceAnchor(tile) {
    if (!tile) return null;
    var priceEl = tile.querySelector('[data-upcart-chunk="cart-item-price"]');
    if (priceEl && priceEl.parentElement) return priceEl.parentElement;
    var compareEl = tile.querySelector('[data-upcart-chunk="cart-item-compare-at-price"]');
    if (compareEl && compareEl.parentElement) return compareEl.parentElement;
    var title =
      tile.querySelector('.upcart-public-component-product-tile__title-link') ||
      tile.querySelector('.upcart-internal-component-product-tile__title-link');
    return title ? title.parentElement || title : null;
  }

  function paintGiftPriceRow(tile, cents) {
    var money = formatGiftMoney(cents);
    var existing = tile.querySelector('.nb-upcart-gift-price');
    var row = existing;
    if (!row) {
      row = document.createElement('div');
      row.className = 'nb-upcart-gift-price';
      row.setAttribute('data-nb-gift-price', '1');
      var anchor = giftPriceAnchor(tile);
      if (anchor && anchor.parentElement) {
        if (anchor.querySelector('[data-upcart-chunk="cart-item-price"]')) {
          anchor.appendChild(row);
        } else {
          anchor.insertAdjacentElement('afterend', row);
        }
      } else {
        tile.appendChild(row);
      }
    }
    row.innerHTML =
      (money ? '<span class="nb-upcart-gift-price__was">' + money + '</span>' : '') +
      '<span class="nb-upcart-gift-price__free">FREE</span>' +
      (money ? '<span class="nb-upcart-gift-price__save">(Save ' + money + ')</span>' : '');
  }

  function stripSubscribeUiInCart() {
    var root = cartRoot() || document;
    var overlays = root.querySelectorAll('.nb-sub-overlay, .nb-sub-freq');
    for (var i = 0; i < overlays.length; i++) {
      safeRemoveNode(overlays[i]);
    }
    var hosts = root.querySelectorAll(
      '.upcart-public-component-product-tile__subscription-upgrade,' +
        '.upcart-internal-component-product-tile__subscription-upgrade'
    );
    for (var h = 0; h < hosts.length; h++) {
      hosts[h].classList.remove(
        'nb-sub--ready',
        'nb-sub--selected',
        'nb-sub--has-btn',
        'nb-sub--locked',
        'nb-sub--card-pending'
      );
      hosts[h].removeAttribute('data-nb-expanded');
    }
  }

  function enhanceGiftTiles(cart) {
    var listEl = cartItemsListEl();
    if (!listEl) return;
    var lines = cartLineElements(listEl);
    var i;

    if (cart && cart.items && cart.items.length) {
      var used = new Set();
      for (i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (!isGiftCartItem(item)) continue;
        var li = findCartLineForItem(item, listEl, used);
        if (!li) continue;
        var tile = productTileFromCartLine(li);
        if (!tile) continue;
        tile.classList.add('nb-upcart-gift-tile');
        paintGiftPriceRow(tile, giftValueCents(item, tile));
      }
    }

    for (i = 0; i < lines.length; i++) {
      var lineTile = productTileFromCartLine(lines[i]);
      if (!lineTile || !lineTile.classList.contains('nb-upcart-gift-tile')) continue;
      if (!cart) continue;
      var ctx = cartLineForTile(lineTile, cart);
      if (!ctx || !isGiftCartItem(ctx.item)) {
        lineTile.classList.remove('nb-upcart-gift-tile');
        var stale = lineTile.querySelector('.nb-upcart-gift-price');
        if (stale) safeRemoveNode(stale);
      }
    }
  }

  function scan() {
    pauseObsForScan();
    getCartCached(350)
      .then(function (cart) {
        scanWithCart(cart);
      })
      .catch(function () {
        scanWithCart(null);
      });
  }

  function scanWithCart(cart) {
    try {
      injectStyles();
      var root = cartRoot();
      observedEl = root || null;
      if (!root) detachObs();

      /* NB-014-AB — do not build subscribe/frequency UI; strip leftovers + style gifts */
      try {
        stripSubscribeUiInCart();
      } catch (errSub) {}
      try {
        enhanceGiftTiles(cart);
      } catch (errGift) {}

      if (cart) {
        try {
          pruneStaleLineUi(cart);
          syncCartItemsOrder(cart);
        } catch (errOrder) {}
      }
      try {
        enhanceUpcartFooter();
      } catch (err2) {}
      try {
        restoreBottomModulesInCartBody();
      } catch (err3) {}
      try {
        enhanceUpsellTiles();
      } catch (err4) {}
      try {
        enhanceUpsellTitle();
      } catch (err5) {}
      try {
        if (typeof window.__nbSyncHeaderCartIconBubble === 'function') {
          window.__nbSyncHeaderCartIconBubble(cart);
        }
      } catch (err6) {}
    } finally {
      resumeObsAfterScan();
    }
  }

  function boot() {
    injectStyles();
    ensureFreqDelegation();
    ensureCheckoutLabelObserver();
    scan();
    setTimeout(scheduleScan, 400);
    setTimeout(scheduleScan, 900);
    document.addEventListener('upcart:cartUpdated', function () {
      relabelSecureCheckoutButtons();
      invalidateCartCache();
      burstResync();
    });
    document.addEventListener('cart:updated', function () {
      relabelSecureCheckoutButtons();
      invalidateCartCache();
      burstResync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  }

  /* NB-014-DI — always on; leftover Convert enable APIs stay as no-ops */
  var nbStarted = false;

  function nbActivateGate() {
    document.documentElement.classList.add('nb-upcart-subscribe-redesign-on');
  }

  function nbTryStart() {
    if (nbStarted) return;
    if (window.NB_UPCART_SUBSCRIBE_REDESIGN_FORCE_OFF === true) return;
    nbStarted = true;
    window.NB_UPCART_SUBSCRIBE_REDESIGN = true;
    window.__NB_UPCART_SUBSCRIBE_STARTED = true;
    nbActivateGate();
    main();
  }

  window.nbEnableUpcartSubscribeRedesign = function () {
    window.NB_UPCART_SUBSCRIBE_REDESIGN = true;
    nbTryStart();
  };

  document.addEventListener('nb-upcart-subscribe-redesign:enable', nbTryStart, false);
  nbTryStart();

  (function initHeaderCartIconBubbleSync() {
    var bubbleTimer = null;
    var bubbleBusy = false;

    function headerCartIconRoot() {
      return typeof Shopify !== 'undefined' && Shopify.routes && typeof Shopify.routes.root === 'string'
        ? Shopify.routes.root
        : '/';
    }

    function parseCartIconSectionHtml(html) {
      if (!html) return '';
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var section = doc.querySelector('.shopify-section');
      return section ? section.innerHTML : html;
    }

    function applyHeaderCartIconMarkup(markup) {
      if (!markup) return;
      var links = document.querySelectorAll('#cart-icon-bubble');
      for (var i = 0; i < links.length; i++) {
        links[i].innerHTML = markup;
      }
    }

    function applyHeaderCartIconCount(count) {
      var safe = Math.max(Number(count) || 0, 0);
      var links = document.querySelectorAll('#cart-icon-bubble');
      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var bubble = link.querySelector('.cart-count-bubble');
        if (safe <= 0) {
          if (bubble) bubble.remove();
          continue;
        }
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          link.appendChild(bubble);
        }
        var visible = bubble.querySelector('[aria-hidden="true"]');
        if (!visible) {
          visible = document.createElement('span');
          visible.setAttribute('aria-hidden', 'true');
          bubble.insertBefore(visible, bubble.firstChild);
        }
        visible.textContent = safe < 100 ? String(safe) : '';
      }
    }

    function refreshHeaderCartIconBubbleFromSection() {
      if (bubbleBusy) return;
      bubbleBusy = true;
      fetch(headerCartIconRoot() + '?sections=cart-icon-bubble', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (sections) {
          if (!sections || !sections['cart-icon-bubble']) return;
          applyHeaderCartIconMarkup(parseCartIconSectionHtml(sections['cart-icon-bubble']));
        })
        .catch(function () {})
        .finally(function () {
          bubbleBusy = false;
        });
    }

    function scheduleHeaderCartIconBubbleRefresh() {
      window.clearTimeout(bubbleTimer);
      bubbleTimer = window.setTimeout(refreshHeaderCartIconBubbleFromSection, 120);
    }

    function syncHeaderCartIconBubble(cart) {
      if (cart && typeof cart.item_count === 'number') {
        applyHeaderCartIconCount(cart.item_count);
        return;
      }
      scheduleHeaderCartIconBubbleRefresh();
    }

    window.__nbSyncHeaderCartIconBubble = syncHeaderCartIconBubble;
    window.__nbRefreshHeaderCartIconBubble = scheduleHeaderCartIconBubbleRefresh;

    [
      'cart:updated',
      'cart:update',
      'cart:refresh',
      'cart:change',
      'upcart:cartUpdated',
      'upcart:item-added',
      'upcart:open',
    ].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleHeaderCartIconBubbleRefresh);
      window.addEventListener(eventName, scheduleHeaderCartIconBubbleRefresh);
    });

    document.addEventListener('submit', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('form[action*="/cart/add"]')) {
        scheduleHeaderCartIconBubbleRefresh();
      }
    });

    if (!window.__nbHeaderCartIconFetchPatched) {
      window.__nbHeaderCartIconFetchPatched = true;
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        return nativeFetch.apply(this, args).then(function (result) {
          try {
            var url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
            if (url && /\/cart(\.js|\/add|\/change|\/update|\/clear)/.test(String(url))) {
              scheduleHeaderCartIconBubbleRefresh();
            }
          } catch (eFetch) {}
          return result;
        });
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshHeaderCartIconBubbleFromSection, { once: true });
    } else {
      refreshHeaderCartIconBubbleFromSection();
    }
  })();
})();
